import { useCssVars as P, createElementBlock as i, openBlock as t, createElementVNode as o, createCommentVNode as r, renderSlot as s, toDisplayString as b, normalizeStyle as Me, computed as H, normalizeClass as h, createVNode as T, unref as v, useSlots as M, createBlock as $, resolveDynamicComponent as O, withCtx as C, ref as L, watch as Y, withModifiers as ne, nextTick as le, withDirectives as ce, vShow as ue, Fragment as B, renderList as D, onMounted as ie, mergeProps as Se, createTextVNode as Q, Transition as De, onUnmounted as He, createSlots as Z } from "vue";
/* empty css                      */
import { _ as x, v as ee, d as ze, c as Re, b as K } from "./ds-atom-stars-BUhywkw8.js";
import { f as Ne, a as Oe, b as Ue, c as Ve, d as Ke, e as Fe, g as qe, h as Ge, i as Ye, j as je, k as Xe, l as We, m as Je, n as Qe, o as Ze, p as et, q as tt, r as at, s as nt, t as lt, u as it, v as st, w as rt, x as ot, y as ct, z as ut, A as dt, B as gt, C as ft, D as mt, E as ht, F as bt, G as yt, H as kt, I as vt, J as St, K as pt, L as _t, M as $t, N as Ct, O as wt, P as Pt, Q as xt, R as It, S as Lt, T as Tt, U as Et, V as At, W as Bt, X as Mt, Y as Dt, Z as Ht, _ as zt, $ as Rt, a0 as Nt, a1 as Ot, a2 as Ut, a3 as Vt, a4 as Kt, a5 as Ft, a6 as qt, a7 as Gt, a8 as Yt, a9 as jt, aa as Xt, ab as Wt, ac as Jt, ad as Qt, ae as Zt, af as ea, ag as ta, ah as aa, ai as na, aj as la, ak as ia, al as pe, am as _e, an as sa, ao as ra, ap as oa, aq as ca, ar as ua, as as da, at as ga, au as fa, av as ma, aw as ha, ax as ba, ay as ya, az as ka, aA as va, aB as Sa, aC as pa, aD as _a, aE as $a, aF as Ca, aG as wa, aH as te, aI as de, aJ as ge, aK as fe, aL as Pa, aM as xa, aN as Ia, aO as La, aP as Ta, aQ as ae, aR as $e, aS as Ce, aT as me } from "./get-container-size-i7P_LLh9.js";
import { storeToRefs as F } from "pinia";
/* empty css              */
const Ea = { class: "bar-process-container" }, Aa = { class: "bar-process" }, Ba = {
  key: 0,
  class: "bar-process__text"
}, Ma = {
  key: 0,
  class: "bar-process__percentage u-regular u-bold"
}, Da = {
  key: 0,
  class: "bar-process__status u-tiny-text"
}, Ha = { class: "bar-process__bar" }, za = {
  __name: "ds-atom-bar-process",
  props: {
    showPercentage: {
      type: Boolean,
      default: !0
    },
    percentage: {
      type: [String, Number],
      required: !0,
      default: ""
    },
    status: {
      type: String,
      default: ""
    },
    statusColor: {
      type: String,
      default: ""
    },
    percentageColor: {
      type: String,
      default: ""
    },
    barBackground: {
      type: String,
      default: ""
    },
    filledBarBackground: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    P((l) => ({
      c85cec04: a.status,
      "4886b05d": a.percentageColor,
      "8701dbd6": a.barBackground,
      "3538bcd3": a.filledBarBackground
    }));
    const a = e;
    return (l, n) => (t(), i("div", Ea, [
      o("div", Aa, [
        e.showPercentage && e.percentage || e.status ? (t(), i("div", Ba, [
          s(l.$slots, "percentage", { classes: ["bar-process__percentage"] }, () => [
            e.showPercentage && e.percentage ? (t(), i("div", Ma, b(e.percentage) + "% ", 1)) : r("", !0)
          ], !0),
          s(l.$slots, "status", { classes: ["bar-process__status"] }, () => [
            e.status ? (t(), i("p", Da, b(e.status), 1)) : r("", !0)
          ], !0)
        ])) : r("", !0),
        o("div", Ha, [
          o("div", {
            class: "bar-process__bar-filled",
            style: Me({ width: `${e.percentage}%` })
          }, null, 4)
        ])
      ])
    ]));
  }
}, Ki = /* @__PURE__ */ x(za, [["__scopeId", "data-v-dcb3fcf1"]]), Ra = {
  faThumbsUp: Ca,
  faThumbsDown: $a,
  faEnvelope: _a,
  faMagnifyingGlass: pa,
  faCheck: Sa,
  faPhone: va,
  faStar: ka,
  faHeart: ya,
  faArrowRight: ba,
  faArrowLeft: ha,
  faArrowDown: ma,
  faArrowUp: fa,
  faCircleXmark: ga,
  faXmark: da,
  faCircleInfo: ua,
  faShare: ca,
  faCircleExclamation: oa,
  faLink: ra,
  faInfo: sa,
  faChevronRight: _e,
  faChevronLeft: pe,
  faChevronDown: ia,
  faChevronUp: la,
  faSquare: na,
  faExclamation: aa,
  faCircleCheck: ta,
  faCircleChevronRight: ea,
  faCircleChevronLeft: Zt,
  faCircleChevronDown: Qt,
  faCircleChevronUp: Jt,
  faCircleArrowRight: Wt,
  faCircleArrowLeft: Xt,
  faCircleArrowDown: jt,
  faCircleArrowUp: Yt,
  faClock: Gt,
  faTriangleExclamation: qt,
  faMinusCircle: Ft,
  faPlusCircle: Kt,
  faMinus: Vt,
  faPlus: Ut,
  faLocationDot: Ot,
  faBus: Nt,
  faFacebook: Rt,
  faLinkedin: zt,
  faYoutube: Ht,
  faGoogle: Dt,
  faInstagram: Mt,
  faTiktok: Bt,
  faWordpress: At,
  faPinterest: Et,
  faXTwitter: Tt,
  faTwitter: Lt,
  faPinterestP: It,
  faLinkedinIn: xt,
  faFacebookF: Pt,
  faThumbsUpSolid: wt,
  faThumbsDownSolid: Ct,
  faEnvelopeSolid: $t,
  faCheckSolid: _t,
  faPhoneSolid: pt,
  faStarSolid: St,
  faHeartSolid: vt,
  faArrowRightSolid: kt,
  faArrowLeftSolid: yt,
  faArrowDownSolid: bt,
  faArrowUpSolid: ht,
  faCircleXmarkSolid: mt,
  faXmarkSolid: ft,
  faCircleInfoSolid: gt,
  faShareSolid: dt,
  faCircleExclamationSolid: ut,
  faLinkSolid: ct,
  faInfoSolid: ot,
  faChevronRightSolid: rt,
  faChevronLeftSolid: st,
  faChevronDownSolid: it,
  faChevronUpSolid: lt,
  faSquareSolid: nt,
  faExclamationSolid: at,
  faCircleCheckSolid: tt,
  faCircleChevronRightSolid: et,
  faCircleChevronLeftSolid: Ze,
  faCircleChevronDownSolid: Qe,
  faCircleChevronUpSolid: Je,
  faCircleArrowRightSolid: We,
  faCircleArrowLeftSolid: Xe,
  faCircleArrowDownSolid: je,
  faCircleArrowUpSolid: Ye,
  faClockSolid: Ge,
  faTriangleExclamationSolid: qe,
  faMinusCircleSolid: Fe,
  faPlusCircleSolid: Ke,
  faMinusSolid: Ve,
  faPlusSolid: Ue,
  faLocationDotSolid: Oe,
  faBusSolid: Ne
}, Na = {
  __name: "ds-atom-icon",
  props: {
    icon: {
      type: String,
      required: !0
    },
    type: {
      type: String,
      default: "solid"
    },
    size: {
      type: [String, Number],
      default: "auto"
    },
    color: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    P((n) => ({
      f4fbf58c: a.color
    })), wa.add(Ra);
    const a = e, l = H(() => a.type === "solid" ? "fas" : a.type === "regular" ? "far" : "fab");
    return (n, d) => (t(), i("div", {
      class: h(["icon", `icon--${e.size}`])
    }, [
      T(v(te), {
        icon: [l.value, a.icon]
      }, null, 8, ["icon"])
    ], 2));
  }
}, A = /* @__PURE__ */ x(Na, [["__scopeId", "data-v-64909933"]]), Oa = { class: "mp-button-container" }, Ua = { class: "mp-button__inner" }, Va = { class: "mp-button__icon" }, Ka = {
  key: 0,
  class: "mp-button__icon"
}, Fa = ["innerHTML"], qa = { class: "mp-button-wrapper" }, Ga = {
  key: 0,
  class: "mp-button__icon"
}, Ya = ["innerHTML"], ja = {
  key: 2,
  class: "mp-button__icon"
}, Xa = { class: "mp-button__underline-text u-tiny-text" }, N = {
  __name: "ds-atom-button",
  props: {
    buttonType: {
      type: String,
      default: "main"
    },
    component: {
      type: [String, Object],
      default: "button"
    },
    href: {
      type: [String, Object],
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "large"
    },
    fullWidth: {
      type: Boolean,
      default: !1
    },
    fitWidthMobile: {
      type: Boolean,
      default: !1
    },
    text: {
      type: String,
      default: null
    },
    textAlignment: {
      type: String,
      default: "center"
    },
    iconType: {
      type: String,
      default: "regular"
    },
    iconLeft: {
      type: String,
      default: ""
    },
    iconRight: {
      type: String,
      default: ""
    },
    enableUnderline: {
      type: Boolean,
      default: !1
    },
    underlineText: {
      type: String,
      default: ""
    },
    underlineIcon: {
      type: String,
      default: ""
    },
    underlineAlignment: {
      type: String,
      default: "left"
    },
    enableBackButton: {
      type: Boolean,
      default: !1
    },
    backButtonComponent: {
      type: String,
      default: "button"
    },
    backButtonHref: {
      type: String,
      default: ""
    },
    backButtonDisabled: {
      type: Boolean,
      default: !1
    },
    backIcon: {
      type: String,
      default: ""
    },
    backText: {
      type: String,
      default: "Back"
    }
  },
  emits: ["click", "back"],
  setup(e, { emit: a }) {
    const l = M(), n = e, d = a, c = (u) => {
      n.disabled || d("click", u);
    }, k = (u) => {
      n.backButtonDisabled || d("back", u);
    };
    return (u, f) => (t(), i("div", Oa, [
      e.enableBackButton ? (t(), $(O(e.backButtonComponent), {
        key: 0,
        href: e.backButtonHref,
        class: h([
          "mp-button",
          "mp-button--back",
          `mp-button--${e.size}`,
          {
            "mp-button--disabled": e.backButtonDisabled
          }
        ]),
        "aria-label": e.backText ? e.backText : v(l).backText ? v(l).backText : "button",
        onClick: k
      }, {
        default: C(() => [
          o("span", Ua, [
            o("span", Va, [
              e.backIcon && e.backIcon !== "none" ? (t(), i("span", Ka, [
                T(A, {
                  icon: e.backIcon,
                  type: e.iconType,
                  size: "auto"
                }, null, 8, ["icon", "type"])
              ])) : r("", !0)
            ]),
            u.$slots.backText || e.backText ? s(u.$slots, "backText", {
              key: 0,
              classes: ["mp-button__text"]
            }, () => [
              o("span", {
                class: "mp-button__text mp-button__text--default",
                innerHTML: e.backText
              }, null, 8, Fa)
            ]) : r("", !0)
          ])
        ]),
        _: 3
      }, 8, ["href", "class", "aria-label"])) : r("", !0),
      o("div", qa, [
        (t(), $(O(e.component), {
          href: e.href,
          class: h([
            "mp-button",
            `mp-button--${e.size}`,
            `mp-button--${e.buttonType}`,
            {
              "mp-button--disabled": e.disabled,
              "mp-button--full-width": e.fullWidth,
              "mp-button--fit-width-mobile": e.fitWidthMobile
            }
          ]),
          "aria-label": e.text ? e.text : v(l).text ? v(l).text : "button",
          onClick: c
        }, {
          default: C(() => [
            o("span", {
              class: h(["mp-button__inner", [`mp-button__inner--${e.textAlignment}`]])
            }, [
              e.iconLeft && e.iconLeft !== "none" && e.buttonType !== "link" ? (t(), i("span", Ga, [
                T(A, {
                  icon: e.iconLeft,
                  type: e.iconType,
                  size: "auto"
                }, null, 8, ["icon", "type"])
              ])) : r("", !0),
              u.$slots.text || e.text ? s(u.$slots, "text", {
                key: 1,
                classes: ["mp-button__text"]
              }, () => [
                o("span", {
                  class: "mp-button__text mp-button__text--default",
                  innerHTML: e.text
                }, null, 8, Ya)
              ]) : r("", !0),
              e.iconRight && e.iconRight !== "none" && e.buttonType !== "link" ? (t(), i("span", ja, [
                T(A, {
                  icon: e.iconRight,
                  type: e.iconType,
                  size: "auto"
                }, null, 8, ["icon", "type"])
              ])) : r("", !0)
            ], 2)
          ]),
          _: 3
        }, 8, ["href", "class", "aria-label"])),
        e.enableUnderline ? (t(), i("div", {
          key: 0,
          class: h([
            "mp-button__underline",
            `mp-button__underline--${e.underlineAlignment}`,
            {
              "mp-button__underline--full-width": e.fullWidth
            }
          ])
        }, [
          e.underlineIcon && e.underlineIcon !== "none" ? (t(), $(A, {
            key: 0,
            icon: e.underlineIcon,
            type: e.iconType,
            size: "auto",
            class: "mp-button__underline-icon"
          }, null, 8, ["icon", "type"])) : r("", !0),
          s(u.$slots, "underlineText", { classes: ["mp-button__underline-text"] }, () => [
            o("span", Xa, b(e.underlineText), 1)
          ])
        ], 2)) : r("", !0)
      ])
    ]));
  }
}, Wa = { class: "card-image-small-container" }, Ja = ["src", "alt"], Qa = { class: "card-image-small__inner" }, Za = { class: "card-image-small__content" }, en = {
  key: 0,
  class: "card-image-small__header u-bold"
}, tn = {
  key: 0,
  class: "card-image-small__date"
}, an = {
  key: 0,
  class: "card-image-small__sub-header u-bold"
}, nn = {
  key: 0,
  class: "card-image-small__paragraph"
}, ln = {
  key: 0,
  class: "card-image-small__paragraph-tiny u-tiny-text"
}, sn = {
  key: 0,
  class: "card-image-small__price"
}, rn = {
  __name: "ds-organism-card-image-small",
  props: {
    direction: {
      type: String,
      required: !0
    },
    alignment: {
      type: String,
      default: ""
    },
    buttonType: {
      type: String,
      default: ""
    },
    mediaFormat: {
      type: String,
      default: "fit"
    },
    enableDropShadow: {
      type: Boolean,
      default: !1
    },
    enableArrow: {
      type: Boolean,
      default: !1
    },
    media: {
      type: String,
      default: ""
    },
    alt: {
      type: String,
      default: ""
    },
    buttonLink: {
      type: String,
      default: ""
    },
    header: {
      type: String,
      default: null
    },
    subHeader: {
      type: String,
      default: null
    },
    date: {
      type: String,
      default: null
    },
    paragraph: {
      type: String,
      default: null
    },
    paragraphTiny: {
      type: String,
      default: null
    },
    price: {
      type: String,
      default: null
    },
    button: {
      type: String,
      default: null
    },
    border: {
      type: String,
      default: ""
    },
    background: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    P((l) => ({
      d21a1f1c: a.background,
      "5edf5170": a.border
    }));
    const a = e;
    return (l, n) => (t(), i("section", Wa, [
      o("div", {
        class: h([
          "card-image-small",
          `card-image-small--${e.direction}`,
          `card-image-small--${e.alignment}`,
          {
            "card-image-small--drop-shadow": e.enableDropShadow
          }
        ])
      }, [
        s(l.$slots, "media", {
          classes: [
            "card-image-small__media",
            `card-image-small__media--${e.mediaFormat}`
          ]
        }, () => [
          e.media ? (t(), i("img", {
            key: 0,
            class: h([
              "card-image-small__media",
              `card-image-small__media--${e.mediaFormat}`
            ]),
            src: e.media,
            alt: e.alt
          }, null, 10, Ja)) : r("", !0)
        ], !0),
        o("div", Qa, [
          o("div", Za, [
            s(l.$slots, "header", { classes: ["card-image-small__header"] }, () => [
              e.header ? (t(), i("h4", en, b(e.header), 1)) : r("", !0)
            ], !0),
            s(l.$slots, "date", { classes: ["card-image-small__date"] }, () => [
              e.date ? (t(), i("p", tn, b(e.date), 1)) : r("", !0)
            ], !0),
            s(l.$slots, "subHeader", { classes: ["card-image-small__sub-header"] }, () => [
              e.subHeader ? (t(), i("p", an, b(e.subHeader), 1)) : r("", !0)
            ], !0),
            s(l.$slots, "paragraph", { classes: ["card-image-small__paragraph"] }, () => [
              e.paragraph ? (t(), i("p", nn, b(e.paragraph), 1)) : r("", !0)
            ], !0),
            s(l.$slots, "paragraphTiny", { classes: ["card-image-small__paragraph-tiny"] }, () => [
              e.paragraphTiny ? (t(), i("p", ln, b(e.paragraphTiny), 1)) : r("", !0)
            ], !0),
            s(l.$slots, "price", { classes: ["card-image-small__price"] }, () => [
              e.price ? (t(), i("h5", sn, b(e.price), 1)) : r("", !0)
            ], !0)
          ]),
          s(l.$slots, "actions", {}, () => [
            T(N, {
              "icon-right": e.enableArrow ? "arrow-right" : "none",
              text: e.button,
              size: "small",
              "button-type": e.buttonType,
              "full-width": !0,
              url: e.buttonLink ?? "",
              component: e.buttonLink ? "a" : "button",
              onClick: n[0] || (n[0] = () => e.buttonLink ? "" : console.log("Button clicked"))
            }, null, 8, ["icon-right", "text", "button-type", "url", "component"])
          ], !0)
        ])
      ], 2)
    ]));
  }
}, Fi = /* @__PURE__ */ x(rn, [["__scopeId", "data-v-18c65292"]]), on = ["innerHTML"], cn = ["innerHTML"], un = ["innerHTML"], dn = {
  __name: "ds-atom-heading",
  props: {
    alignment: {
      type: String,
      default: "left"
    },
    enableDivider: {
      type: Boolean,
      default: !1
    },
    topSubtitle: {
      type: String,
      default: null
    },
    heading: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    topSubtitleColor: {
      type: String,
      default: ""
    },
    headingColor: {
      type: String,
      default: ""
    },
    subtitleColor: {
      type: String,
      default: ""
    },
    dividerColor: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    P((l) => ({
      "0be68041": a.topSubtitleColor,
      "17c55d6c": a.headingColor,
      "247df4a0": a.subtitleColor,
      "6b355eb5": a.dividerColor
    }));
    const a = e;
    return (l, n) => (t(), i("div", {
      class: h([
        "heading",
        `heading--align-${e.alignment}`,
        { "heading--divider": e.enableDivider }
      ])
    }, [
      s(l.$slots, "topSubtitle", { classes: ["heading__top-subtitle"] }, () => [
        e.topSubtitle ? (t(), i("span", {
          key: 0,
          class: "heading__top-subtitle u-heading-4",
          innerHTML: e.topSubtitle
        }, null, 8, on)) : r("", !0)
      ], !0),
      s(l.$slots, "heading", { classes: ["heading__heading"] }, () => [
        e.heading ? (t(), i("h2", {
          key: 0,
          class: "heading__heading",
          innerHTML: e.heading
        }, null, 8, cn)) : r("", !0)
      ], !0),
      s(l.$slots, "subtitle", { classes: ["heading__subtitle"] }, () => [
        e.subtitle ? (t(), i("span", {
          key: 0,
          class: "heading__subtitle u-heading-4",
          innerHTML: e.subtitle
        }, null, 8, un)) : r("", !0)
      ], !0)
    ], 2));
  }
}, qi = /* @__PURE__ */ x(dn, [["__scopeId", "data-v-7b5b31de"]]), gn = ["for"], fn = {
  key: 1,
  class: "mp-form-field__footer"
}, mn = {
  key: 0,
  class: "mp-form-field__error u-tiny-text"
}, se = {
  __name: "ds-atom-form-field",
  props: {
    label: {
      type: String,
      default: ""
    },
    valid: {
      type: Boolean,
      default: !0
    },
    error: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (a, l) => (t(), i("div", {
      class: h(["mp-form-field", {
        "mp-form-field--error": e.valid === !1
      }])
    }, [
      e.label ? (t(), i("label", {
        key: 0,
        class: "mp-form-field__label u-tiny-text u-bold",
        for: e.id
      }, b(e.label), 9, gn)) : r("", !0),
      s(a.$slots, "default"),
      e.error || a.$slots.info ? (t(), i("div", fn, [
        e.valid === !1 ? (t(), i("div", mn, b(e.error), 1)) : r("", !0),
        s(a.$slots, "info")
      ])) : r("", !0)
    ], 2));
  }
}, hn = {
  key: 0,
  class: "mp-input-element__prefix"
}, bn = {
  key: 1,
  class: "mp-input-element__icon"
}, yn = ["id", "name", "type", "placeholder", "disabled", "value"], kn = {
  key: 2,
  class: "mp-input-element__suffix"
}, vn = {
  key: 3,
  class: "mp-input-element__search",
  type: "submit",
  "aria-label": "Search"
}, Gi = {
  __name: "ds-atom-input",
  props: {
    id: {
      type: String,
      required: !0
    },
    name: {
      type: String,
      required: !0
    },
    type: {
      type: String,
      required: !0
    },
    size: {
      type: String,
      default: "small"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    isValid: {
      type: Boolean,
      default: !0
    },
    icon: {
      type: String,
      default: null
    },
    error: {
      type: String,
      default: ""
    },
    prefix: {
      type: String,
      default: ""
    },
    suffix: {
      type: String,
      default: ""
    },
    mask: {
      type: String,
      default: ""
    },
    validation: {
      type: String,
      default: ""
    }
  },
  emits: ["updateValue", "updateValidation", "blur", "focus"],
  setup(e, { emit: a }) {
    const l = a, n = e, d = L(null), c = (f) => {
      let g = ze(n.mask, f.target);
      l("updateValue", g), f.target.value !== g && (f.target.value = g);
    };
    Y(() => n.value, (f) => {
      d.value.value = f;
    });
    const k = (f) => {
      const g = ee(n.value, n.validation);
      g !== n.isValid && l("updateValidation", g), l("blur", f);
    }, u = (f) => {
      l("updateValidation", null), l("focus", f);
    };
    return (f, g) => (t(), $(se, {
      id: e.id,
      valid: e.isValid,
      error: e.error,
      label: e.label
    }, {
      default: C(() => [
        o("div", {
          class: h([
            "mp-input-element",
            `mp-input-element--type-${e.type}`,
            `mp-input-element--size-${e.size}`,
            {
              "mp-input-element--has-icon": e.icon,
              "mp-input-element--disabled": e.disabled
            }
          ])
        }, [
          e.prefix ? (t(), i("div", hn, [
            o("span", null, b(e.prefix), 1)
          ])) : e.icon ? (t(), i("div", bn, [
            T(A, {
              icon: e.icon,
              type: "regular",
              size: "auto"
            }, null, 8, ["icon"])
          ])) : r("", !0),
          o("input", {
            id: e.id,
            ref_key: "input",
            ref: d,
            class: "mp-input-element__input",
            name: e.name,
            type: e.type,
            placeholder: e.placeholder,
            disabled: e.disabled,
            value: e.value,
            onInput: ne(c, ["prevent"]),
            onFocus: u,
            onBlur: k
          }, null, 40, yn),
          e.suffix ? (t(), i("div", kn, [
            o("span", null, b(e.suffix), 1)
          ])) : r("", !0),
          e.type === "search" ? (t(), i("button", vn, [
            T(A, {
              icon: "magnifying-glass",
              type: "regular"
            })
          ])) : r("", !0)
        ], 2)
      ]),
      _: 1
    }, 8, ["id", "valid", "error", "label"]));
  }
}, Sn = ["tabindex"], pn = { class: "select-element__field" }, _n = ["id", "tabindex", "value", "name", "disabled"], $n = { class: "select-element__expand" }, Cn = ["value", "onClick"], wn = {
  key: 0,
  class: "select-element__list-item-checkbox"
}, Pn = { class: "select-element__list-item-label" }, Yi = {
  __name: "ds-atom-select",
  props: {
    id: {
      type: String,
      required: !0
    },
    name: {
      type: String,
      required: !0
    },
    search: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "small"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: String || Array,
      default: ""
    },
    multiSelect: {
      type: Boolean,
      default: !1
    },
    isValid: {
      type: Boolean,
      default: !0
    },
    error: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      required: !0
    }
  },
  emits: ["updateValue", "updateValidation", "updateSearchValue", "blur"],
  setup(e, { emit: a }) {
    const l = a, n = e, d = L(!1), c = L(null), k = L(null), u = L(null), f = L(""), g = L(-1), p = L({
      top: !1,
      bottom: !1
    }), m = H(() => n.search ? k.value : c.value), _ = (S) => {
      if (!d.value) return;
      if (S.relatedTarget === c.value || c.value.contains(S.relatedTarget)) {
        S.preventDefault(), c.value.focus();
        return;
      }
      d.value = !1;
      const I = ee(typeof n.value == "object" ? n.value.join(", ") : n.value, "notEmpty");
      I !== n.isValid && l("updateValidation", I), l("blur", S);
    }, y = () => {
      n.disabled || (d.value = !0, l("updateValidation", null), q(), n.search || c.value.focus());
    }, w = (S) => {
      let I = S.value;
      n.multiSelect && (n.value.includes(I) ? I = n.value.filter((E) => E !== S.value) : I = [...n.value, S.value]), S ? l("updateValue", I) : l("updateValidation", !1), n.multiSelect || c.value.blur();
    }, U = (S) => {
      S.preventDefault(), n.search && (f.value = S.target.value, l("updateSearchValue", S.target.value));
    };
    Y(() => n.options, (S) => {
      g.value = S.findIndex((I) => I.value === n.value), q();
    }), Y(() => n.value, (S) => {
      if (!S)
        return;
      if (n.multiSelect)
        n.search || (f.value = n.options.filter((E) => S.includes(E.value)).map((E) => E.label).join(", "));
      else {
        const E = n.options.find((z) => z.value === S);
        f.value = E.label || S, g.value = n.options.findIndex((z) => z.value === S);
      }
      n.search && l("updateSearchValue", f.value);
      const I = ee(typeof n.value == "object" ? n.value.join(", ") : n.value, "notEmpty");
      I !== n.isValid && l("updateValidation", I);
    });
    const X = () => {
      typeof window < "u" && typeof document < "u" && document.addEventListener("keydown", (S) => {
        d.value && (S.key === "Escape" ? (d.value = !1, m.value.blur()) : S.key === "ArrowDown" ? (g.value = g.value !== n.options.length - 1 ? g.value + 1 : 0, V()) : S.key === "ArrowUp" ? (g.value = g.value !== 0 ? g.value - 1 : n.options.length - 1, V()) : S.key === "Enter" && (d.value = !1, m.value.blur(), w(n.options[g.value])));
      });
    }, V = () => {
      const S = c.value.querySelector(".select-element__list"), I = S.querySelectorAll(".select-element__list-item")[g.value];
      S.scrollTop = I.offsetTop;
    }, q = () => {
      le(() => {
        p.value = {
          top: u.value.scrollTop > 20,
          bottom: u.value.scrollTop < u.value.scrollHeight - u.value.clientHeight - 20 && u.value.scrollHeight > u.value.clientHeight
        };
      });
    };
    return X(), (S, I) => (t(), $(se, {
      id: e.id,
      valid: e.isValid,
      error: e.error,
      label: e.label
    }, {
      default: C(() => [
        o("div", {
          ref_key: "element",
          ref: c,
          tabindex: e.search ? -1 : 0,
          class: h(["select-element", {
            "select-element--disabled": e.disabled,
            "select-element--active": d.value,
            "select-element--search": e.search,
            [`select-element--${e.size}`]: !0,
            [`select-element--id-${e.id}`]: !0
          }]),
          onFocus: y,
          onBlur: _
        }, [
          o("div", pn, [
            o("input", {
              id: e.id,
              ref_key: "textField",
              ref: k,
              tabindex: e.search ? null : -1,
              value: f.value,
              type: "search",
              name: e.name,
              class: "select-element__field-input",
              placeholder: " ",
              disabled: e.disabled,
              autocomplete: "nope",
              onFocus: y,
              onInput: U,
              onFocusout: I[0] || (I[0] = (...E) => S.focusOut && S.focusOut(...E)),
              onBlur: _
            }, null, 40, _n),
            ce(o("p", { class: "select-element__placeholder" }, b(e.placeholder), 513), [
              [ue, !f.value]
            ]),
            o("div", $n, [
              T(A, {
                class: "select-element__expand-icon",
                icon: "chevron-down",
                type: "regular",
                size: "auto"
              })
            ])
          ]),
          ce(o("ul", {
            ref_key: "list",
            ref: u,
            class: h(["select-element__list", {
              "select-element__list--shadow-top": p.value.top,
              "select-element__list--shadow-bottom": p.value.bottom
            }]),
            tabindex: "-1",
            onScroll: q
          }, [
            (t(!0), i(B, null, D(e.options, (E, z) => (t(), i("li", {
              key: z,
              value: E.value,
              class: h(["select-element__list-item", {
                "select-element__list-item--selected": z === g.value
              }]),
              onClick: (W) => w(E)
            }, [
              e.multiSelect ? (t(), i("span", wn, [
                e.value.includes(E.value) ? (t(), $(A, {
                  key: 0,
                  icon: "check",
                  type: "solid",
                  size: "auto"
                })) : r("", !0)
              ])) : r("", !0),
              o("span", Pn, b(E.label), 1)
            ], 10, Cn))), 128))
          ], 34), [
            [ue, d.value]
          ])
        ], 42, Sn)
      ]),
      _: 1
    }, 8, ["id", "valid", "error", "label"]));
  }
}, xn = ["id", "name", "placeholder", "disabled", "value"], ji = {
  __name: "ds-atom-textarea",
  props: {
    id: {
      type: String,
      required: !0
    },
    name: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    isValid: {
      type: Boolean,
      default: !0
    },
    error: {
      type: String,
      default: ""
    }
  },
  emits: ["updateValue", "updateValidation", "focus", "blur"],
  setup(e, { emit: a }) {
    const l = a, n = e, d = L(null), c = (f) => {
      let g = f.target.value;
      l("updateValue", g);
    };
    Y(() => n.value, (f) => {
      d.value.value = f;
    });
    const k = (f) => {
      const g = !!n.value;
      g !== n.isValid && l("updateValidation", g), l("blur", f);
    }, u = (f) => {
      l("updateValidation", null), l("focus", f);
    };
    return (f, g) => (t(), $(se, {
      id: e.id,
      valid: e.isValid,
      error: e.error,
      label: e.label
    }, {
      default: C(() => [
        o("textarea", {
          id: e.id,
          ref_key: "textarea",
          ref: d,
          class: h([
            "textarea-element u-paragraph",
            {
              "textarea-element--disabled": e.disabled
            }
          ]),
          name: e.name,
          placeholder: e.placeholder,
          disabled: e.disabled,
          value: e.value,
          onInput: ne(c, ["prevent"]),
          onFocus: u,
          onBlur: k
        }, null, 42, xn)
      ]),
      _: 1
    }, 8, ["id", "valid", "error", "label"]));
  }
}, In = { class: "item-icon__content" }, Ln = { class: "item-icon__text" }, Tn = { class: "item-icon__text-content" }, En = { class: "item-icon__text-heading u-heading-4" }, An = { class: "item-icon__text-paragraph u-paragraph" }, Bn = { class: "item-icon__text-paragraph-tiny u-tiny-text" }, Xi = {
  __name: "ds-molecule-item-icon",
  props: {
    alignment: {
      type: String,
      default: "left"
    },
    verticalAlignment: {
      type: String,
      default: "top"
    },
    heading: {
      type: String,
      default: ""
    },
    clickableHeading: {
      type: Boolean,
      default: !1
    },
    clickableHeadingUrl: {
      type: String,
      default: ""
    },
    paragraph: {
      type: String,
      default: ""
    },
    paragraphTiny: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    iconType: {
      type: String,
      default: "regular"
    },
    iconColor: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const a = M();
    return (l, n) => (t(), i("li", {
      class: h([
        "item-icon",
        `item-icon--${e.alignment}`,
        `item-icon--item-${e.verticalAlignment}`
      ])
    }, [
      o("div", In, [
        o("div", Ln, [
          e.icon || v(a).icon ? s(l.$slots, "icon", {
            key: 0,
            classes: ["item-icon__icon"]
          }, () => [
            e.icon ? (t(), $(A, {
              key: 0,
              class: "item-icon__icon",
              icon: e.icon,
              type: e.iconType,
              color: e.iconColor,
              size: "24"
            }, null, 8, ["icon", "type", "color"])) : r("", !0)
          ]) : r("", !0),
          o("div", Tn, [
            e.clickableHeading && (e.heading || v(a).heading) ? (t(), $(N, {
              key: 0,
              class: "item-icon__text-button",
              "button-type": "text",
              size: "medium",
              "text-alignment": e.alignment,
              component: "a",
              href: e.clickableHeadingUrl,
              "fit-width-mobile": ""
            }, {
              text: C(({ classes: d }) => [
                s(l.$slots, "heading", {
                  classes: ["item-icon__text-heading", d]
                }, () => [
                  o("h4", {
                    class: h([d, "item-icon__text-heading u-heading-4"])
                  }, b(e.heading), 3)
                ])
              ]),
              _: 3
            }, 8, ["text-alignment", "href"])) : r("", !0),
            !e.clickableHeading && (e.heading || v(a).heading) ? s(l.$slots, "heading", {
              key: 1,
              classes: ["item-icon__text-heading"]
            }, () => [
              o("h4", En, b(e.heading), 1)
            ]) : r("", !0),
            e.paragraph || v(a).paragraph ? s(l.$slots, "paragraph", {
              key: 2,
              classes: ["item-icon__text-paragraph"]
            }, () => [
              o("p", An, b(e.paragraph), 1)
            ]) : r("", !0),
            e.paragraphTiny || v(a).paragraphTiny ? s(l.$slots, "paragraphTiny", {
              key: 3,
              classes: ["item-icon__text-paragraph-tiny"]
            }, () => [
              o("p", Bn, b(e.paragraphTiny), 1)
            ]) : r("", !0)
          ])
        ]),
        s(l.$slots, "action", {
          classes: [
            "item-icon__action",
            {
              "item-icon__action--padded": e.icon
            }
          ]
        })
      ])
    ], 2));
  }
}, Mn = (e) => {
  if (typeof document > "u") return e.replace(/<\/?[^>]+>/ig, "");
}, Dn = { class: "magazine-article-card-container" }, Hn = {
  key: 0,
  class: "magazine-article-card__image-container"
}, zn = ["src", "alt"], Rn = { class: "magazine-article-card__content" }, Nn = { class: "magazine-article-card__content-main" }, On = {
  key: 0,
  class: "magazine-article-card__content-title u-heading-4"
}, Un = {
  key: 0,
  class: "u-regular magazine-article-card__content-date"
}, Vn = {
  key: 0,
  class: "u-regular magazine-article-card__content-description"
}, Kn = {
  __name: "ds-molecule-magazine-article-card",
  props: {
    cardLinkTag: {
      type: String,
      default: "a"
    },
    url: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    image: {
      type: Object,
      default: null
    },
    date: {
      type: String,
      default: ""
    },
    background: {
      type: String,
      default: ""
    },
    titleColor: {
      type: String,
      default: ""
    },
    titleHoverColor: {
      type: String,
      default: ""
    },
    textColor: {
      type: String,
      default: ""
    },
    dateColor: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    P((l) => ({
      "69b72fe2": a.background,
      a1683268: a.titleColor,
      "751d4484": a.titleHoverColor,
      "2a7e8996": a.textColor,
      "19c37954": a.dateColor
    }));
    const a = e;
    return (l, n) => (t(), i("section", Dn, [
      e.url ? (t(), $(O(e.cardLinkTag ?? "a"), {
        key: 0,
        class: "magazine-article-card",
        href: e.url
      }, {
        default: C(() => [
          s(l.$slots, "image", { classes: ["magazine-article-card__image"] }, () => {
            var d;
            return [
              (d = e.image) != null && d.src ? (t(), i("div", Hn, [
                o("img", {
                  class: "magazine-article-card__image",
                  src: e.image.src,
                  alt: e.image.alt ?? ""
                }, null, 8, zn)
              ])) : r("", !0)
            ];
          }, !0),
          o("div", Rn, [
            o("div", Nn, [
              s(l.$slots, "title", { classes: ["magazine-article-card__content-title"] }, () => [
                e.title ? (t(), i("h3", On, b(e.title), 1)) : r("", !0)
              ], !0),
              s(l.$slots, "date", { classes: ["magazine-article-card__content-date"] }, () => [
                e.date ? (t(), i("p", Un, b(e.date), 1)) : r("", !0)
              ], !0)
            ]),
            s(l.$slots, "description", { classes: ["magazine-article-card__content-description"] }, () => [
              e.description ? (t(), i("p", Vn, b(v(Mn)(e.description)), 1)) : r("", !0)
            ], !0)
          ])
        ]),
        _: 3
      }, 8, ["href"])) : r("", !0)
    ]));
  }
}, Fn = /* @__PURE__ */ x(Kn, [["__scopeId", "data-v-5359d692"]]), qn = { class: "mp-trust-container" }, Gn = { class: "u-tiny-text mp-trust__text" }, Yn = ["href"], jn = ["src", "alt"], Xn = {
  __name: "ds-molecule-trust",
  props: {
    type: {
      type: String,
      default: "rounded"
    },
    fitWidth: {
      type: Boolean,
      default: !1
    },
    stars: {
      type: Number,
      required: !0
    },
    showRating: {
      type: Boolean,
      default: !0
    },
    showText: {
      type: Boolean,
      default: !1
    },
    text: {
      type: String,
      default: null
    },
    textClickable: {
      type: Boolean,
      default: !1
    },
    textUrl: {
      type: String,
      default: null
    },
    alignment: {
      type: String,
      default: "start"
    },
    showDividers: {
      type: Boolean,
      default: !1
    },
    showLogo: {
      type: Boolean,
      default: !1
    },
    background: {
      type: String,
      default: null
    },
    darkMode: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    P((d) => ({
      "39a3bd6c": a.background
    }));
    const a = e, l = M(), n = H(() => a.type === "rounded" ? null : a.darkMode ? new URL((/* @__PURE__ */ Object.assign({ "../../../../assets/logos/feedback-company-darkmode.svg": fe, "../../../../assets/logos/trustpilot-darkmode.svg": ge, "../../../../assets/logos/yelp-darkmode.svg": de }))[`../../../../assets/logos/${a.type}-darkmode.svg`], import.meta.url).href : new URL((/* @__PURE__ */ Object.assign({ "../../../../assets/logos/facebook.svg": Ta, "../../../../assets/logos/feedback-company-darkmode.svg": fe, "../../../../assets/logos/feedback-company.svg": La, "../../../../assets/logos/google.svg": Ia, "../../../../assets/logos/trustpilot-darkmode.svg": ge, "../../../../assets/logos/trustpilot.svg": xa, "../../../../assets/logos/yelp-darkmode.svg": de, "../../../../assets/logos/yelp.svg": Pa }))[`../../../../assets/logos/${a.type}.svg`], import.meta.url).href);
    return (d, c) => (t(), i("div", qn, [
      o("article", {
        class: h([
          "mp-trust",
          `mp-trust--alignment-${e.alignment}`,
          {
            "mp-trust--background": e.background,
            "mp-trust--dark-mode": e.darkMode,
            "mp-trust--fit-width": e.fitWidth
          }
        ])
      }, [
        T(Re, {
          type: e.type,
          stars: e.stars,
          size: "s",
          "show-rating": e.showRating,
          "dark-mode": e.darkMode
        }, null, 8, ["type", "stars", "show-rating", "dark-mode"]),
        e.text || v(l).text ? (t(), i("div", {
          key: 0,
          class: h([
            "mp-trust__text-wrapper",
            {
              "mp-trust__text-wrapper--divider": e.showDividers
            }
          ])
        }, [
          e.textClickable ? r("", !0) : s(d.$slots, "text", {
            key: 0,
            classes: "mp-trust__text"
          }, () => [
            o("p", Gn, b(e.text), 1)
          ], !0),
          e.textClickable && e.textUrl ? s(d.$slots, "text", {
            key: 1,
            classes: "mp-trust__text mp-trust__text--clickable"
          }, () => [
            o("a", {
              class: "mp-trust__text mp-trust__text--clickable u-tiny-text",
              href: e.textUrl
            }, b(e.text), 9, Yn)
          ], !0) : r("", !0)
        ], 2)) : r("", !0),
        e.showLogo && (n.value || v(l).logo) ? (t(), i("div", {
          key: 1,
          class: h([
            "mp-trust__logo-wrapper",
            {
              "mp-trust__logo-wrapper--divider": e.showDividers
            }
          ])
        }, [
          s(d.$slots, "logo", { class: "mp-trust__logo" }, () => [
            o("img", {
              class: "mp-trust__logo",
              src: n.value,
              alt: e.type
            }, null, 8, jn)
          ], !0)
        ], 2)) : r("", !0)
      ], 2)
    ]));
  }
}, we = /* @__PURE__ */ x(Xn, [["__scopeId", "data-v-9e1df232"]]), Wn = { class: "single-review-container" }, Jn = { class: "single-review__content" }, Qn = {
  key: 0,
  class: "u-bold single-review__heading"
}, Zn = {
  key: 0,
  class: "u-bold single-review__sub-heading"
}, el = {
  key: 0,
  class: "single-review__date"
}, tl = {
  __name: "ds-molecule-single-review",
  props: {
    showStars: {
      type: Boolean,
      default: !1
    },
    background: {
      type: String,
      default: ""
    },
    arrow: {
      type: String,
      default: "off"
    },
    heading: {
      type: String,
      default: ""
    },
    subHeading: {
      type: String,
      default: ""
    },
    date: {
      type: String,
      default: ""
    },
    paragraph: {
      type: String,
      default: ""
    },
    button: {
      type: String,
      default: "See more"
    },
    buttonLess: {
      type: String,
      default: "See less"
    },
    stars: {
      type: Number,
      default: 0
    }
  },
  setup(e) {
    P((f) => ({
      "93e791da": a.background
    }));
    const a = e, l = K(), n = L(null), d = L(!1), c = L(!1), { device: k } = F(l);
    ie(() => {
      u();
    }), Y(k, (f) => {
      u();
    });
    const u = () => {
      n.value.length !== 0 && (c.value = !1, le(() => {
        const f = window.getComputedStyle(document.body), g = parseInt(f.getPropertyValue("--paragraph-line-height"));
        let m = parseInt(f.getPropertyValue("--default-paragraph-line-height"));
        g && (m = g);
        let _ = Math.ceil(n.value.offsetHeight / m);
        (k.value === "mobile" || k.value === "tablet") && (_ = Math.ceil(parseFloat(ae(n.value.offsetHeight)) / m)), _ > 3 ? (c.value = !0, d.value = !0) : (d.value = !1, c.value = !1);
      }));
    };
    return (f, g) => (t(), i("div", Wn, [
      o("div", {
        class: h([
          "single-review",
          `single-review--arrow-${e.arrow}`,
          {
            "single-review--arrow": e.arrow !== "off" && e.background,
            "single-review--background": e.background
          }
        ])
      }, [
        e.showStars ? (t(), $(we, {
          key: 0,
          stars: e.stars,
          "show-rating": !1
        }, null, 8, ["stars"])) : r("", !0),
        o("div", Jn, [
          s(f.$slots, "heading", { classes: ["single-review__heading"] }, () => [
            e.heading ? (t(), i("h4", Qn, b(e.heading), 1)) : r("", !0)
          ], !0),
          s(f.$slots, "subHeading", { classes: ["single-review__sub-heading"] }, () => [
            e.subHeading ? (t(), i("p", Zn, b(e.subHeading), 1)) : r("", !0)
          ], !0),
          s(f.$slots, "date", { classes: ["single-review__date"] }, () => [
            e.date ? (t(), i("p", el, b(e.date), 1)) : r("", !0)
          ], !0),
          o("div", {
            ref_key: "paragraphRef",
            ref: n,
            class: "single-review__paragraph-wrapper"
          }, [
            s(f.$slots, "paragraph", {
              classes: [
                "single-review__paragraph",
                {
                  "single-review__paragraph--collapse": c.value
                }
              ]
            }, () => [
              e.paragraph ? (t(), i("p", {
                key: 0,
                class: h([
                  "single-review__paragraph",
                  {
                    "single-review__paragraph--collapse": c.value
                  }
                ])
              }, b(e.paragraph), 3)) : r("", !0)
            ], !0)
          ], 512),
          s(f.$slots, "action", {
            classes: ["single-review__button"],
            show: d.value,
            paragraphExtended: c.value,
            onClick: () => c.value = !c.value
          }, () => [
            d.value ? (t(), $(N, {
              key: 0,
              text: c.value ? e.button : e.buttonLess,
              class: "single-review__button",
              size: "small",
              "text-alignment": "left",
              "icon-right": c.value ? "chevron-down" : "chevron-up",
              "button-type": "text",
              "fit-width-mobile": "",
              onClick: g[0] || (g[0] = () => c.value = !c.value)
            }, null, 8, ["text", "icon-right"])) : r("", !0)
          ], !0)
        ])
      ], 2)
    ]));
  }
}, Wi = /* @__PURE__ */ x(tl, [["__scopeId", "data-v-f542be34"]]), al = { class: "card-icon-container" }, nl = { class: "card-icon" }, ll = { class: "card-icon__content" }, il = ["innerHTML"], sl = ["innerHTML"], rl = ["innerHTML"], ol = {
  __name: "ds-organism-card-icon",
  props: {
    icon: {
      type: String,
      required: !0,
      default: ""
    },
    header: {
      type: String,
      default: null
    },
    subheader: {
      type: String,
      default: null
    },
    paragraph: {
      type: String,
      default: null
    },
    background: {
      type: String,
      default: ""
    },
    iconColor: {
      type: String,
      default: ""
    },
    headerColor: {
      type: String,
      default: ""
    },
    headerHoverColor: {
      type: String,
      default: ""
    },
    borderColor: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    P((l) => ({
      d0698ebe: a.background,
      "78e76ed2": a.iconColor
    }));
    const a = e;
    return M(), (l, n) => (t(), i("div", al, [
      o("section", nl, [
        s(l.$slots, "icon", { classes: ["card-icon__icon"] }, () => [
          T(A, {
            icon: e.icon,
            class: "card-icon__icon",
            type: "solid",
            size: "auto"
          }, null, 8, ["icon"])
        ], !0),
        o("div", ll, [
          s(l.$slots, "header", { classes: ["card-icon__header"] }, () => [
            o("div", {
              class: "card-icon__header",
              innerHTML: e.header
            }, null, 8, il)
          ], !0),
          s(l.$slots, "subHeader", { classes: ["card-icon__sub-header"] }, () => [
            o("div", {
              class: "card-icon__sub-header",
              innerHTML: e.subheader
            }, null, 8, sl)
          ], !0),
          s(l.$slots, "paragraph", { classes: ["card-icon__paragraph"] }, () => [
            o("div", {
              classes: ["card-icon__paragraph"],
              innerHTML: e.paragraph
            }, null, 8, rl)
          ], !0)
        ])
      ])
    ]));
  }
}, Ji = /* @__PURE__ */ x(ol, [["__scopeId", "data-v-92314529"]]), cl = { class: "card-image-container" }, ul = { class: "card-image__media-wrapper" }, dl = ["src", "alt"], gl = { class: "card-image__information" }, fl = { class: "card-image__heading" }, ml = {
  key: 0,
  class: "card-image__sub-heading"
}, hl = {
  key: 0,
  class: "card-image__date"
}, bl = {
  key: 0,
  class: "card-image__paragraph"
}, yl = {
  key: 0,
  class: "card-image__paragraph-tiny u-tiny-text"
}, kl = {
  key: 0,
  class: "card-image__price"
}, vl = {
  __name: "ds-organism-card-image",
  props: {
    direction: {
      type: String,
      default: "horizontal"
    },
    imageType: {
      type: String,
      default: "filled"
    },
    alignment: {
      type: String,
      default: "left"
    },
    showBackground: {
      type: Boolean,
      default: !0
    },
    showStars: {
      type: Boolean,
      default: !0
    },
    showDivider: {
      type: Boolean,
      default: !1
    },
    showShadow: {
      type: Boolean,
      default: !0
    },
    clickableHeading: {
      type: Boolean,
      default: !1
    },
    buttonIconLeft: {
      type: String,
      default: "none"
    },
    buttonIconRight: {
      type: String,
      default: "none"
    },
    starsText: {
      type: String,
      default: ""
    },
    stars: {
      type: Number,
      default: 0
    },
    src: {
      type: String,
      default: ""
    },
    alt: {
      type: String,
      default: ""
    },
    clickableHeadingUrl: {
      type: String,
      default: ""
    },
    clickableHeadingComponent: {
      type: String,
      default: "a"
    },
    heading: {
      type: String,
      default: ""
    },
    subHeading: {
      type: String,
      default: ""
    },
    date: {
      type: String,
      default: ""
    },
    paragraph: {
      type: String,
      default: ""
    },
    paragraphTiny: {
      type: String,
      default: ""
    },
    price: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      default: ""
    },
    buttonLink: {
      type: String,
      default: ""
    },
    buttonComponent: {
      type: String,
      default: "a"
    },
    backgroundColor: {
      type: String,
      default: ""
    },
    dividerColor: {
      type: String,
      default: ""
    },
    borderColor: {
      type: String,
      default: ""
    },
    headingColor: {
      type: String,
      default: ""
    },
    subHeadingColor: {
      type: String,
      default: ""
    },
    dateColor: {
      type: String,
      default: ""
    },
    paragraphColor: {
      type: String,
      default: ""
    },
    paragraphTinyColor: {
      type: String,
      default: ""
    },
    priceColor: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    P((n) => ({
      "273a9b29": l.backgroundColor,
      c1ede014: l.dividerColor,
      "539f74eb": l.borderColor
    }));
    const a = M(), l = e;
    return (n, d) => (t(), i("article", cl, [
      o("div", {
        class: h([
          "card-image",
          `card-image--${e.direction}`,
          {
            "card-image--background": e.showBackground,
            "card-image--divider": !e.showBackground & e.showDivider,
            "card-image--shadow": e.showShadow
          }
        ])
      }, [
        o("div", ul, [
          s(n.$slots, "media", {
            classes: [
              "card-image__media",
              `card-image__media--${e.imageType}`
            ]
          }, () => [
            e.src ? (t(), i("img", {
              key: 0,
              class: h([
                "card-image__media",
                `card-image__media--${e.imageType}`
              ]),
              src: e.src,
              alt: e.alt ?? ""
            }, null, 10, dl)) : r("", !0)
          ], !0)
        ]),
        o("div", {
          class: h([
            "card-image__content",
            `card-image__content--${e.alignment}`
          ])
        }, [
          o("div", gl, [
            e.clickableHeading && (e.heading || v(a).heading) ? (t(), $(N, {
              key: 0,
              class: "card-image__text-button",
              "button-type": "text",
              size: "medium",
              "text-alignment": e.alignment,
              component: e.clickableHeadingComponent,
              href: e.clickableHeadingUrl,
              "full-width": !1
            }, {
              text: C(({ classes: c }) => [
                s(n.$slots, "heading", {
                  classes: ["card-image__heading", c]
                }, () => [
                  o("h4", {
                    class: h([c, "card-image__heading"])
                  }, b(e.heading), 3)
                ], !0)
              ]),
              _: 3
            }, 8, ["text-alignment", "component", "href"])) : r("", !0),
            !e.clickableHeading && (e.heading || v(a).heading) ? s(n.$slots, "heading", {
              key: 1,
              classes: ["card-image__heading"]
            }, () => [
              o("h4", fl, b(e.heading), 1)
            ], !0) : r("", !0),
            s(n.$slots, "subHeading", {
              class: h(["card-image__sub-heading"])
            }, () => [
              e.subHeading ? (t(), i("p", ml, b(e.subHeading), 1)) : r("", !0)
            ], !0),
            s(n.$slots, "date", {
              class: h(["card-image__date"])
            }, () => [
              e.date ? (t(), i("p", hl, b(e.date), 1)) : r("", !0)
            ], !0),
            s(n.$slots, "paragraph", {
              class: h(["card-image__paragraph"])
            }, () => [
              e.paragraph ? (t(), i("p", bl, b(e.paragraph), 1)) : r("", !0)
            ], !0),
            e.showStars ? (t(), $(we, {
              key: 2,
              class: "card-image__trust",
              "fit-width": "",
              stars: e.stars,
              text: e.starsText,
              "show-rating": !1
            }, null, 8, ["stars", "text"])) : r("", !0),
            s(n.$slots, "paragraphTiny", {
              class: h(["card-image__paragraph-tiny"])
            }, () => [
              e.paragraphTiny ? (t(), i("p", yl, b(e.paragraphTiny), 1)) : r("", !0)
            ], !0),
            s(n.$slots, "price", {
              class: h(["card-image__price"])
            }, () => [
              e.price ? (t(), i("h5", kl, b(e.price), 1)) : r("", !0)
            ], !0)
          ]),
          s(n.$slots, "action", { classes: ["card-image__button"] }, () => [
            e.buttonText ? (t(), $(N, {
              key: 0,
              text: e.buttonText,
              "icon-left": e.buttonIconLeft,
              "icon-right": e.buttonIconRight,
              url: e.buttonLink,
              component: e.buttonComponent,
              "button-type": "secondary",
              size: "small",
              class: "card-image__button"
            }, {
              text: C(({ classes: c }) => [
                s(n.$slots, "buttonText", { classes: c }, void 0, !0)
              ]),
              _: 3
            }, 8, ["text", "icon-left", "icon-right", "url", "component"])) : r("", !0)
          ], !0)
        ], 2)
      ], 2)
    ]));
  }
}, he = /* @__PURE__ */ x(vl, [["__scopeId", "data-v-9a7ebcef"]]), Sl = { class: "card-list-container" }, pl = {
  key: 0,
  class: "card-list__heading"
}, _l = {
  key: 1,
  class: "card-list__footer"
}, $l = {
  __name: "ds-organism-card-list",
  props: {
    items: {
      type: Array,
      required: !0
    },
    sliderOnMobile: {
      type: Boolean,
      default: !0
    },
    itemsOnRowDesktop: {
      type: Number,
      default: 3
    },
    textColor: {
      type: String,
      default: ""
    },
    enableBackground: {
      type: Boolean,
      default: !0
    },
    background: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    P((f) => ({
      dfc3ecba: c.value,
      bd9cc14c: e.itemsOnRowDesktop,
      "63af75f3": n.background,
      "312b3e5e": n.textColor
    }));
    const a = K(), { device: l } = F(a), n = e, d = M(), c = H(() => n.items.length), k = H(() => l.value === "mobile" && n.sliderOnMobile ? $e : "div"), u = H(() => l.value === "mobile" && n.sliderOnMobile ? Ce : "div");
    return (f, g) => (t(), i("div", Sl, [
      o("section", {
        class: h([
          "card-list",
          {
            "card-list--background": e.enableBackground
          }
        ])
      }, [
        v(d).heading ? (t(), i("div", pl, [
          s(f.$slots, "heading", {}, void 0, !0)
        ])) : r("", !0),
        (t(), $(O(k.value), {
          class: "card-list__items",
          options: {
            type: "fade",
            rewind: !0,
            arrows: !1,
            pagination: !0
          }
        }, {
          default: C(() => [
            (t(!0), i(B, null, D(e.items, (p, m) => (t(), $(O(u.value), {
              key: m,
              class: "card-list__item"
            }, {
              default: C(() => [
                s(f.$slots, "item", Se({ ref_for: !0 }, p), void 0, !0)
              ]),
              _: 2
            }, 1024))), 128))
          ]),
          _: 3
        })),
        v(d).footer ? (t(), i("div", _l, [
          s(f.$slots, "footer", {}, void 0, !0)
        ])) : r("", !0)
      ], 2)
    ]));
  }
}, Qi = /* @__PURE__ */ x($l, [["__scopeId", "data-v-4cab3ca2"]]), Cl = { class: "card-list-links-container" }, wl = ["src", "alt"], Pl = { class: "card-list-links__content-head" }, xl = { class: "card-list-links__list" }, Il = {
  __name: "ds-organism-card-list-links",
  props: {
    imageType: {
      type: String,
      default: null
    },
    src: {
      type: String,
      default: null
    },
    alt: {
      type: String,
      default: null
    },
    heading: {
      type: String,
      default: null
    },
    headingUrl: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      default: () => []
    },
    alignment: {
      type: String,
      default: "left"
    },
    enableShowMoreButton: {
      type: Boolean,
      default: !1
    },
    enableBackground: {
      type: Boolean,
      default: !1
    },
    enableDivider: {
      type: Boolean,
      default: !1
    },
    backgroundColor: {
      type: String,
      default: null
    },
    dividerColor: {
      type: String,
      default: null
    },
    linkComponent: {
      type: [String, Object],
      default: "a"
    }
  },
  setup(e) {
    P((c) => ({
      ea727366: n.backgroundColor,
      dd25515c: n.dividerColor
    }));
    const a = L(!1), l = M(), n = e, d = H(() => a.value ? n.items : n.items.slice(0, 4));
    return (c, k) => (t(), i("article", Cl, [
      o("div", {
        class: h([
          "card-list-links",
          {
            "card-list-links--background": e.enableBackground
          }
        ])
      }, [
        e.src || v(l).media ? (t(), i("div", {
          key: 0,
          class: h([
            "card-list-links__media-wrapper",
            `card-list-links__media-wrapper--${e.imageType}`
          ])
        }, [
          s(c.$slots, "media", { classes: ["card-list-links__media"] }, () => [
            o("img", {
              class: "card-list-links__media",
              src: e.src,
              alt: e.alt ?? ""
            }, null, 8, wl)
          ], !0)
        ], 2)) : r("", !0),
        o("div", {
          class: h([
            "card-list-links__content",
            `card-list-links__content--${e.alignment}`
          ])
        }, [
          o("div", Pl, [
            e.heading || v(l).heading ? (t(), $(N, {
              key: 0,
              "button-type": "text",
              size: "medium",
              component: e.linkComponent,
              href: e.headingUrl,
              "icon-right": "arrow-right",
              "text-alignment": e.alignment,
              class: h([
                "card-list-links__heading-button",
                { "card-list-links__heading-button--divider": e.enableDivider }
              ])
            }, {
              text: C(({ classes: u }) => [
                s(c.$slots, "heading", { classes: u }, () => [
                  o("h4", {
                    class: h(u)
                  }, b(e.heading), 3)
                ], !0)
              ]),
              _: 3
            }, 8, ["component", "href", "text-alignment", "class"])) : r("", !0),
            o("ul", xl, [
              (t(!0), i(B, null, D(d.value, (u, f) => (t(), i("li", {
                key: f,
                class: "card-list-links__list-item"
              }, [
                T(N, {
                  "button-type": "text",
                  size: "small",
                  component: e.linkComponent,
                  href: u.href,
                  "icon-left": "chevron-right",
                  "text-alignment": e.alignment
                }, {
                  text: C((g) => [
                    s(c.$slots, "listItemText", Se({ ref_for: !0 }, { ...g, item: u }), () => [
                      o("p", {
                        class: h([
                          g.classes,
                          "u-paragraph",
                          "u-bold"
                        ])
                      }, b(u.text), 3)
                    ], !0)
                  ]),
                  _: 2
                }, 1032, ["component", "href", "text-alignment"])
              ]))), 128))
            ])
          ]),
          e.enableShowMoreButton && e.items.length > 4 ? (t(), $(N, {
            key: 0,
            "button-type": "text",
            size: "small",
            component: "text",
            "icon-right": a.value ? "chevron-up" : "chevron-down",
            class: "card-list-links__more-button",
            "text-alignment": e.alignment,
            onClick: k[0] || (k[0] = (u) => a.value = !a.value)
          }, {
            text: C(({ classes: u }) => [
              s(c.$slots, "showMoreButtonText", { classes: u }, () => [
                o("p", {
                  class: h([
                    u,
                    "u-tiny-text",
                    "u-bold"
                  ])
                }, b(a.value ? "Show less" : "Show more"), 3)
              ], !0)
            ]),
            _: 3
          }, 8, ["icon-right", "text-alignment"])) : r("", !0)
        ], 2)
      ], 2)
    ]));
  }
}, Zi = /* @__PURE__ */ x(Il, [["__scopeId", "data-v-3f57ce41"]]);
function Ll(e) {
  const a = parseInt(window.getComputedStyle(e).lineHeight);
  return e.clientHeight > a;
}
const Tl = { class: "content-column-checkmarks-container" }, El = { class: "content-column-checkmarks__inner" }, Al = {
  key: 0,
  class: "content-column-checkmarks__heading"
}, Bl = {
  key: 0,
  class: "content-column-checkmarks__subheading"
}, Ml = ["innerHTML"], Dl = ["href"], Hl = {
  __name: "ds-organism-content-column-checkmarks",
  props: {
    items: {
      type: Array,
      required: !0
    },
    heading: {
      type: String,
      default: null
    },
    subheading: {
      type: String,
      default: null
    },
    headingsPosition: {
      type: String,
      default: "left"
    },
    columnCount: {
      type: String,
      default: "1"
    },
    mediaSize: {
      type: String,
      default: "small"
    },
    mediaPosition: {
      type: String,
      default: "above"
    },
    turnOnBackground: {
      type: Boolean,
      default: !1
    },
    background: {
      type: String,
      default: null
    },
    iconColor: {
      type: String,
      default: null
    },
    headingColor: {
      type: String,
      default: null
    },
    subheadingColor: {
      type: String,
      default: null
    },
    titleColor: {
      type: String,
      default: null
    },
    titleHoverColor: {
      type: String,
      default: null
    },
    titleActiveColor: {
      type: String,
      default: null
    },
    textColor: {
      type: String,
      default: null
    },
    buttonColor: {
      type: String,
      default: null
    },
    buttonHoverColor: {
      type: String,
      default: null
    },
    buttonActiveColor: {
      type: String,
      default: null
    }
  },
  setup(e) {
    P((g) => ({
      "0a6e68e8": c.value,
      "8976625c": a.iconColor,
      d1b90c74: a.background,
      "598cddce": a.headingColor,
      "33278b29": a.subheadingColor,
      "7b4af883": a.titleColor,
      49087332: a.titleHoverColor,
      "5f65d2c4": a.textColor,
      ff23948e: a.buttonColor,
      "07fc5af1": a.buttonHoverColor,
      "17e8bc5a": a.buttonActiveColor
    }));
    const a = e, l = M(), n = L([]), d = L([]), c = H(
      () => Math.min(a.items.length, parseInt(a.columnCount))
    ), k = {
      checkmark: "check",
      "checkmark-circle": "circle-check",
      "circle-info": "circle-info",
      heart: "heart",
      star: "star"
    }, u = H(() => a.mediaSize === "small" ? "24" : a.mediaSize === "medium" ? "32" : a.mediaSize === "large" ? "40" : "auto");
    ie(() => {
      le(() => {
        n.value.forEach((g, p) => {
          Ll(g) && (d.value[p] = !0);
        });
      });
    });
    const f = (g) => d.value[g];
    return (g, p) => (t(), i("article", Tl, [
      o("div", {
        class: h([
          "content-column-checkmarks",
          { "content-column-checkmarks--background": e.turnOnBackground }
        ])
      }, [
        o("div", El, [
          e.heading || e.subheading || v(l).heading || v(l).subheading ? (t(), i("div", {
            key: 0,
            class: h([
              "content-column-checkmarks__header",
              `content-column-checkmarks__header--${e.headingsPosition}`
            ])
          }, [
            s(g.$slots, "heading", {
              classes: [
                "content-column-checkmarks__heading",
                `content-column-checkmarks__header--${e.headingsPosition}`
              ]
            }, () => [
              e.heading ? (t(), i("h3", Al, b(e.heading), 1)) : r("", !0)
            ], !0),
            s(g.$slots, "subheading", { classes: ["content-column-checkmarks__subheading"] }, () => [
              e.subheading ? (t(), i("h4", Bl, b(e.subheading), 1)) : r("", !0)
            ], !0)
          ], 2)) : r("", !0),
          o("ul", {
            class: h([
              "content-column-checkmarks__list",
              `content-column-checkmarks__list--${e.mediaPosition}`
            ])
          }, [
            (t(!0), i(B, null, D(e.items, (m, _) => (t(), i("li", {
              key: _,
              class: "content-column-checkmarks__item"
            }, [
              s(g.$slots, "icon", {
                item: m,
                classes: [
                  "content-column-checkmarks__item-image",
                  `content-column-checkmarks__item-image--${e.mediaSize}`
                ]
              }, () => [
                m.icon && m.mediaType === "icon" ? (t(), $(A, {
                  key: 0,
                  icon: k[m.icon],
                  type: k[m.icon] === "circle-info" ? "solid" : "regular",
                  size: u.value,
                  class: h([
                    "content-column-checkmarks__item-image"
                  ])
                }, null, 8, ["icon", "type", "size"])) : r("", !0)
              ], !0),
              o("div", {
                class: h([
                  "content-column-checkmarks__item-content",
                  m.title && !m.buttonLabel && !m.text ? "content-column-checkmarks__item-content--only-title" : ""
                ])
              }, [
                m.title ? s(g.$slots, "itemTitle", {
                  key: 0,
                  classes: [
                    "content-column-checkmarks__item-title",
                    { "content-column-checkmarks__item-title--link": m.url }
                  ],
                  title: m.title,
                  url: m.url ?? ""
                }, () => [
                  (t(), $(O(m.url ? "a" : "h4"), {
                    href: m.url,
                    class: h([
                      "content-column-checkmarks__item-title u-heading-4 u-bold",
                      m.url ? "content-column-checkmarks__item-title--link" : ""
                    ])
                  }, {
                    default: C(() => [
                      Q(b(m.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["href", "class"]))
                ], !0) : r("", !0),
                m.text ? s(g.$slots, "itemText", {
                  key: 1,
                  classes: [
                    "content-column-checkmarks__item-text",
                    { "content-column-checkmarks__item-text--multiline": f(_) }
                  ],
                  text: m.text
                }, () => [
                  o("div", {
                    ref_for: !0,
                    ref_key: "itemTextRefs",
                    ref: n,
                    class: h([
                      "content-column-checkmarks__item-text",
                      { "content-column-checkmarks__item-text--multiline": f(_) }
                    ]),
                    innerHTML: m.text
                  }, null, 10, Ml)
                ], !0) : r("", !0),
                m.hideButton ? r("", !0) : s(g.$slots, "button", {
                  key: 2,
                  classes: ["content-column-checkmarks__item-button"]
                }, () => [
                  m.buttonLabel && m.buttonUrl ? (t(), i("a", {
                    key: 0,
                    class: "content-column-checkmarks__item-button",
                    href: m.buttonUrl
                  }, b(m.buttonLabel), 9, Dl)) : r("", !0)
                ], !0)
              ], 2)
            ]))), 128))
          ], 2)
        ])
      ], 2)
    ]));
  }
}, es = /* @__PURE__ */ x(Hl, [["__scopeId", "data-v-2f86f118"]]), zl = { class: "block-information-container" }, Rl = {
  key: 0,
  class: "block-information__wrapper"
}, Nl = {
  key: 0,
  class: "block-information__heading u-paragraph u-bold"
}, Ol = {
  __name: "ds-organism-block-information",
  props: {
    type: {
      type: String,
      default: "general"
    },
    enableBackground: {
      type: Boolean,
      default: !1
    },
    background: {
      type: String,
      default: null
    },
    showBorder: {
      type: Boolean,
      default: !0
    },
    icon: {
      type: String,
      default: null
    },
    heading: {
      type: String,
      default: null
    }
  },
  setup(e) {
    P((n) => ({
      "377cc054": l.background || null
    }));
    const a = M(), l = e;
    return (n, d) => (t(), i("div", zl, [
      o("section", {
        class: h([
          "block-information",
          `block-information--type-${e.type}`,
          { "block-information--background": e.enableBackground },
          { "block-information--no-border": !e.showBorder }
        ])
      }, [
        s(n.$slots, "icon", { classes: "block-information__icon" }, () => [
          e.icon ? (t(), $(A, {
            key: 0,
            icon: e.icon,
            size: "24",
            class: "block-information__icon"
          }, null, 8, ["icon"])) : r("", !0)
        ], !0),
        e.heading || v(a).heading || v(a).content ? (t(), i("div", Rl, [
          s(n.$slots, "heading", { classes: "block-information__heading" }, () => [
            e.heading ? (t(), i("p", Nl, b(e.heading), 1)) : r("", !0)
          ], !0),
          s(n.$slots, "content", { classes: "block-information__content" }, void 0, !0),
          s(n.$slots, "action", {}, void 0, !0)
        ])) : r("", !0)
      ], 2)
    ]));
  }
}, Ul = /* @__PURE__ */ x(Ol, [["__scopeId", "data-v-d4757cc6"]]), Vl = { class: "mp-cta-block-container" }, Kl = { class: "mp-cta-block__header" }, Fl = {
  key: 0,
  class: "mp-cta-block__heading u-heading-3"
}, ql = ["innerHTML"], Gl = { class: "mp-cta-block__content" }, Yl = { class: "u-paragraph u-bold" }, jl = {
  __name: "ds-organism-cta-block",
  props: {
    heading: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    itemsOnRowDesktop: {
      type: Number,
      default: 1
    },
    enableBackground: {
      type: Boolean,
      default: !0
    },
    background: {
      type: String,
      default: ""
    },
    textColor: {
      type: String,
      default: ""
    },
    success: {
      type: Boolean,
      default: !1
    },
    successMessage: {
      type: String,
      default: ""
    },
    successMessageBackground: {
      type: String,
      default: ""
    },
    successMessageTextColor: {
      type: String,
      default: ""
    }
  },
  emits: ["submit"],
  setup(e, { emit: a }) {
    P((u) => ({
      "0f51a364": n.background || null,
      "23bec3a4": n.textColor || null,
      "98c5c36c": n.successMessageTextColor || null,
      "1cf0d81c": n.itemsOnRowDesktop
    }));
    const l = a, n = e, d = () => {
      l("submit");
    }, c = (u) => {
      const f = u.parentElement;
      f.style.height = u.clientHeight + "px";
    }, k = (u) => {
      const f = u.parentElement;
      setTimeout(() => {
        f.style.height = u.clientHeight + "px";
      }, 50), setTimeout(() => {
        f.style.height = "";
      }, 350);
    };
    return (u, f) => (t(), i("div", Vl, [
      o("section", {
        class: h([
          "mp-cta-block",
          {
            "mp-cta-block--background": e.enableBackground
          }
        ])
      }, [
        o("div", Kl, [
          s(u.$slots, "heading", { classes: ["mp-cta-block__heading"] }, () => [
            e.heading ? (t(), i("h2", Fl, b(e.heading), 1)) : r("", !0)
          ], !0),
          s(u.$slots, "text", { classes: ["mp-cta-block__text"] }, () => [
            e.text ? (t(), i("div", {
              key: 0,
              class: "mp-cta-block__text",
              innerHTML: e.text
            }, null, 8, ql)) : r("", !0)
          ], !0)
        ]),
        o("div", Gl, [
          T(De, {
            name: "mp-cta-block-content-transition",
            mode: "out-in",
            onBeforeLeave: c,
            onEnter: k
          }, {
            default: C(() => [
              e.success ? (t(), $(Ul, {
                key: 1,
                class: "mp-cta-block__information",
                "enable-background": !0,
                background: e.successMessageBackground,
                "show-border": !1
              }, {
                content: C(() => [
                  s(u.$slots, "successMessage", {}, () => [
                    o("p", Yl, b(e.successMessage), 1)
                  ], !0)
                ]),
                _: 3
              }, 8, ["background"])) : (t(), i("form", {
                key: 0,
                class: "mp-cta-block__form",
                onSubmit: ne(d, ["prevent"])
              }, [
                s(u.$slots, "form", {}, void 0, !0)
              ], 32))
            ]),
            _: 3
          })
        ])
      ], 2)
    ]));
  }
}, ts = /* @__PURE__ */ x(jl, [["__scopeId", "data-v-207f34f3"]]), Xl = { class: "cta-with-image-container" }, Wl = { class: "cta-with-image__wrapper" }, Jl = { class: "cta-with-image__content" }, Ql = { class: "cta-with-image__content-head" }, Zl = {
  key: 0,
  class: "cta-with-image__subheading u-heading-5"
}, ei = {
  key: 0,
  class: "cta-with-image__description u-paragraph"
}, ti = {
  key: 0,
  class: "cta-with-image__content-body"
}, ai = {
  key: 0,
  class: "cta-with-image__media-container"
}, ni = ["src", "alt"], li = {
  __name: "ds-organism-cta-with-image",
  props: {
    heading: {
      type: String,
      default: null
    },
    headingDivider: {
      type: Boolean,
      default: !0
    },
    subheading: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    media: {
      type: String,
      default: null
    },
    mediaAlt: {
      type: String,
      default: "Media"
    },
    showMediaOnMobile: {
      type: Boolean,
      default: !0
    },
    mediaPosition: {
      type: String,
      default: "left"
    },
    enableBackground: {
      type: Boolean,
      default: !1
    },
    background: {
      type: String,
      default: null
    }
  },
  setup(e) {
    P((c) => ({
      "3c7d3cf4": d.background
    }));
    const a = K(), { device: l } = F(a), n = M(), d = e;
    return (c, k) => (t(), i("div", Xl, [
      o("article", {
        class: h([
          "cta-with-image",
          `cta-with-image--media-${e.mediaPosition}`,
          { "cta-with-image--background": e.enableBackground }
        ])
      }, [
        o("div", Wl, [
          o("div", Jl, [
            o("div", Ql, [
              s(c.$slots, "heading", {
                classes: [
                  "cta-with-image__heading",
                  { "cta-with-image__heading--divider": e.headingDivider }
                ]
              }, () => [
                e.heading ? (t(), i("h2", {
                  key: 0,
                  class: h([
                    "cta-with-image__heading u-heading-3",
                    { "cta-with-image__heading--divider": e.headingDivider }
                  ])
                }, b(e.heading), 3)) : r("", !0)
              ], !0),
              s(c.$slots, "subheading", { classes: ["cta-with-image__subheading"] }, () => [
                e.subheading ? (t(), i("h3", Zl, b(e.subheading), 1)) : r("", !0)
              ], !0),
              s(c.$slots, "description", { classes: ["cta-with-image__description"] }, () => [
                e.description ? (t(), i("p", ei, b(e.description), 1)) : r("", !0)
              ], !0)
            ]),
            v(n).body || v(n).action ? (t(), i("div", ti, [
              s(c.$slots, "body", { classes: ["cta-with-image__body"] }, void 0, !0),
              s(c.$slots, "action", { classes: ["cta-with-image__action"] }, void 0, !0)
            ])) : r("", !0)
          ]),
          v(l) === "desktop" || v(l) === "tablet" || e.showMediaOnMobile ? (t(), i("div", ai, [
            s(c.$slots, "media", { classes: ["cta-with-image__media"] }, () => [
              e.media ? (t(), i("img", {
                key: 0,
                class: "cta-with-image__media",
                src: e.media,
                alt: e.mediaAlt
              }, null, 8, ni)) : r("", !0)
            ], !0)
          ])) : r("", !0)
        ])
      ], 2)
    ]));
  }
}, as = /* @__PURE__ */ x(li, [["__scopeId", "data-v-3e5ed554"]]), ii = { class: "icon-link-bar-container" }, si = { class: "icon-link-bar" }, ri = {
  key: 1,
  class: "media-hero__share-text"
}, oi = { class: "icon-link-bar__items" }, ci = ["href", "aria-label"], ui = {
  __name: "ds-organism-icon-link-bar",
  props: {
    shareText: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    iconBackgroundColor: {
      type: String,
      default: null
    },
    iconColor: {
      type: String,
      default: null
    }
  },
  setup(e) {
    P((n) => ({
      "3b11cf20": a.iconBackgroundColor,
      "465b86be": a.iconColor
    }));
    const a = e, l = M();
    return (n, d) => (t(), i("div", ii, [
      o("article", si, [
        v(l).shareText ? s(n.$slots, "header", {
          key: 0,
          classes: ["icon-link-bar__share-text"]
        }, void 0, !0) : e.shareText ? (t(), i("h5", ri, b(e.shareText), 1)) : r("", !0),
        o("div", oi, [
          (t(!0), i(B, null, D(e.items, (c) => (t(), i("a", {
            href: c.url,
            target: "_blank",
            class: "icon-link-bar__item",
            "aria-label": `${c.type} icon`
          }, [
            T(A, {
              icon: c.type,
              type: "brand",
              size: "auto",
              class: h([
                "icon-link-bar__item-icon",
                `icon-link-bar__item-icon--${c.type}`
              ])
            }, null, 8, ["icon", "class"])
          ], 8, ci))), 256))
        ])
      ])
    ]));
  }
}, ns = /* @__PURE__ */ x(ui, [["__scopeId", "data-v-bb1b9f71"]]), di = { class: "image-list__carousel-wrapper" }, gi = {
  key: 1,
  class: "image-list__carousel--no-slider"
}, fi = {
  __name: "ds-organism-image-list",
  props: {
    component: {
      type: String,
      default: "a"
    },
    title: {
      type: String,
      default: ""
    },
    titleAlignment: {
      type: String,
      default: "left"
    },
    enableDivider: {
      type: Boolean,
      default: !0
    },
    enableNavigation: {
      type: Boolean,
      default: !0
    },
    items: {
      type: Array,
      default: () => []
    },
    background: {
      type: String,
      default: null
    }
  },
  setup(e) {
    P((m) => ({
      "5b70df2c": a.background
    }));
    const a = e, l = K(), { device: n } = F(l), d = L(null), c = L(null), k = L(null), u = L({
      enable: !1,
      width: null,
      perPage: 5,
      gap: null,
      padding: null
    });
    ie(() => {
      k.value = me(d.value), f();
      const m = new ResizeObserver(() => {
        const _ = me(d.value);
        _ !== k.value && (k.value = _, f());
      });
      m.observe(d.value), He(() => {
        m.disconnect();
      });
    });
    const f = () => {
      var m;
      if (u.value = {
        enable: !1,
        perPage: null,
        gap: null
      }, !!((m = a.items) != null && m.length)) {
        if (n.value === "mobile" && a.items.length > 1)
          g({
            enable: !0,
            perPage: 1,
            gap: 4,
            padding: 12,
            focus: "center"
          });
        else if (n.value === "tablet" || n.value === "desktop")
          switch (k.value) {
            case "s":
              g({
                enable: !0,
                perPage: 1,
                gap: 8,
                padding: 14,
                focus: "center"
              });
              break;
            case "m":
              g({
                enable: !0,
                perPage: 1,
                gap: 16,
                padding: 14,
                focus: "center"
              });
              break;
            case "l":
              g({
                enable: !0,
                perPage: 2,
                gap: 16,
                padding: 0
              });
              break;
            case "xl":
              g({
                enable: !0,
                perPage: 3,
                gap: 16,
                padding: 0,
                focus: "center"
              });
              break;
          }
      }
    }, g = (m) => {
      (n.value === "mobile" || n.value === "tablet") && (typeof m.padding == "number" && (m.padding = ae(m.padding)), m.gap = ae(m.gap)), u.value = m;
    }, p = M();
    return (m, _) => (t(), i("div", {
      ref_key: "container",
      ref: d,
      class: "image-list-container"
    }, [
      o("article", {
        class: h([
          "image-list",
          {
            "image-list--background": e.background,
            "image-list--hidden-nav": !e.enableNavigation
          }
        ])
      }, [
        s(m.$slots, "title", {
          classes: [
            "image-list__title",
            `image-list__title--${e.titleAlignment}`,
            e.enableDivider && "image-list__title--divider"
          ]
        }, () => [
          e.title ? (t(), i("h2", {
            key: 0,
            class: h([
              "image-list__title",
              `image-list__title--${e.titleAlignment}`,
              e.enableDivider && "image-list__title--divider"
            ])
          }, b(e.title), 3)) : r("", !0)
        ], !0),
        o("div", di, [
          e.items.length > u.value.perPage && e.enableNavigation ? (t(), $(v($e), {
            key: 0,
            ref_key: "slider",
            ref: c,
            class: "image-list__carousel",
            options: {
              type: "loop",
              gap: u.value.gap,
              perPage: u.value.perPage,
              padding: u.value.padding,
              focus: u.value.focus,
              arrows: !1,
              rewind: !0
            }
          }, {
            default: C(() => [
              (t(!0), i(B, null, D(e.items, (y, w) => (t(), $(v(Ce), {
                key: w,
                class: "image-list__item"
              }, {
                default: C(() => [
                  (t(), $(O(e.component), {
                    href: y.url,
                    class: h([
                      "image-list__url-item"
                    ])
                  }, {
                    default: C(() => [
                      T(he, {
                        direction: "vertical",
                        alignment: "center",
                        "image-type": "square",
                        src: y.src,
                        "clickable-heading": y.url !== null && y.url !== "",
                        "clickable-heading-url": y.url !== null && y.url !== "" ? y.url : null,
                        "show-background": !1,
                        "show-stars": !1,
                        "show-divider": !1,
                        "show-shadow": !1,
                        heading: y.title
                      }, Z({ _: 2 }, [
                        v(p).itemMedia ? {
                          name: "media",
                          fn: C(({ classes: U }) => [
                            s(m.$slots, "itemMedia", {
                              item: y,
                              classes: U
                            }, void 0, !0)
                          ]),
                          key: "0"
                        } : void 0
                      ]), 1032, ["src", "clickable-heading", "clickable-heading-url", "heading"])
                    ]),
                    _: 2
                  }, 1032, ["href"]))
                ]),
                _: 2
              }, 1024))), 128))
            ]),
            _: 3
          }, 8, ["options"])) : (t(), i("div", gi, [
            (t(!0), i(B, null, D(e.items, (y, w) => (t(), i("div", {
              key: w,
              class: "image-list__item"
            }, [
              (t(), $(O(e.component), {
                href: y.url,
                class: h([
                  "image-list__url-item"
                ])
              }, {
                default: C(() => [
                  T(he, {
                    direction: "vertical",
                    alignment: "center",
                    "image-type": "square",
                    "clickable-heading": y.url !== null && y.url !== "",
                    "clickable-heading-url": y.url !== null && y.url !== "" ? y.url : null,
                    src: y.src,
                    "show-background": !1,
                    "show-stars": !1,
                    "show-divider": !1,
                    "show-shadow": !1,
                    heading: y.title
                  }, Z({ _: 2 }, [
                    v(p).itemMedia ? {
                      name: "media",
                      fn: C(({ classes: U }) => [
                        s(m.$slots, "itemMedia", {
                          item: y,
                          classes: U
                        }, void 0, !0)
                      ]),
                      key: "0"
                    } : void 0
                  ]), 1032, ["clickable-heading", "clickable-heading-url", "src", "heading"])
                ]),
                _: 2
              }, 1032, ["href"]))
            ]))), 128))
          ])),
          e.items.length > u.value.perPage && e.enableNavigation ? (t(), i("button", {
            key: 2,
            class: "image-list__arrow image-list__arrow--previous",
            "aria-label": "Previous",
            onClick: _[0] || (_[0] = (y) => c.value.go(`-${u.value.perPage}`))
          }, [
            T(A, {
              class: "image-list__arrow-icon",
              icon: "chevron-left"
            })
          ])) : r("", !0),
          e.items.length > u.value.perPage && e.enableNavigation ? (t(), i("button", {
            key: 3,
            class: "image-list__arrow image-list__arrow--next",
            "aria-label": "Next",
            onClick: _[1] || (_[1] = (y) => c.value.go(`+${u.value.perPage}`))
          }, [
            T(A, {
              class: "image-list__arrow-icon",
              icon: "chevron-right"
            })
          ])) : r("", !0)
        ])
      ], 2)
    ], 512));
  }
}, ls = /* @__PURE__ */ x(fi, [["__scopeId", "data-v-adf08a2f"]]), mi = { class: "link-block-container" }, hi = { class: "link-block__heading u-bold" }, bi = { class: "link-block__columns" }, yi = ["href"], ki = {
  key: 0,
  class: "link-block__list link-block__list--secondary"
}, vi = ["href"], Si = {
  __name: "ds-organism-link-block",
  props: {
    heading: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      default: () => []
    },
    enableBackground: {
      type: Boolean,
      default: !0
    },
    backgroundColor: {
      type: String,
      default: null
    }
  },
  setup(e) {
    P((k) => ({
      b3ad1a60: n.backgroundColor
    }));
    const a = K(), { device: l } = F(a), n = e;
    function d(k) {
      const u = k.map((p) => {
        var _;
        const m = ((_ = p.children) == null ? void 0 : _.length) || 0;
        return {
          ...p,
          totalItems: 1 + m
        };
      });
      u.sort((p, m) => m.totalItems - p.totalItems);
      const f = [[], [], []], g = [0, 0, 0];
      return u.forEach((p) => {
        const m = g.indexOf(Math.min(...g));
        f[m].push(p), g[m] += p.totalItems;
      }), f;
    }
    const c = H(() => l.value === "mobile" ? [n.items] : d(n.items));
    return (k, u) => (t(), i("section", mi, [
      o("div", {
        class: h([
          "link-block",
          {
            "link-block--background": e.enableBackground
          }
        ])
      }, [
        s(k.$slots, "heading", { classes: ["link-block__heading u-bold"] }, () => [
          o("h3", hi, b(e.heading), 1)
        ], !0),
        o("div", bi, [
          (t(!0), i(B, null, D(c.value, (f, g) => (t(), i("ul", {
            key: g,
            class: "link-block__list"
          }, [
            (t(!0), i(B, null, D(f, (p, m) => {
              var _;
              return t(), i("li", {
                key: m,
                class: "link-block__item"
              }, [
                s(k.$slots, "item", {
                  item: p,
                  classes: ["link-block__item-link"]
                }, () => [
                  o("a", {
                    href: p.href,
                    class: "link-block__item-link"
                  }, b(p.title), 9, yi)
                ], !0),
                (_ = p.children) != null && _.length ? (t(), i("ul", ki, [
                  (t(!0), i(B, null, D(p.children, (y, w) => (t(), i("li", {
                    key: w,
                    class: "link-block__item u-tiny-text"
                  }, [
                    s(k.$slots, "subitem", {
                      item: y,
                      classes: ["link-block__item-link--secondary"]
                    }, () => [
                      o("a", {
                        href: y.href,
                        class: "link-block__item-link--secondary"
                      }, b(y.title), 9, vi)
                    ], !0)
                  ]))), 128))
                ])) : r("", !0)
              ]);
            }), 128))
          ]))), 128))
        ])
      ], 2)
    ]));
  }
}, is = /* @__PURE__ */ x(Si, [["__scopeId", "data-v-730af390"]]), pi = { class: "list-magazine-articles-container" }, _i = ["href"], $i = {
  __name: "ds-organism-list-magazine-articles",
  props: {
    heading: {
      type: String,
      default: null
    },
    enableHeadingDivider: {
      type: Boolean,
      default: !1
    },
    items: {
      type: Array,
      required: !0
    },
    enableItemDivider: {
      type: Boolean,
      default: !1
    },
    linkUrl: {
      type: String,
      default: null
    },
    linkLabel: {
      type: String,
      default: null
    },
    listStyle: {
      type: String,
      default: "horizontal"
    },
    background: {
      type: String,
      default: null
    },
    titleColor: {
      type: String,
      default: null
    },
    dividerColor: {
      type: String,
      default: null
    },
    linkColor: {
      type: String,
      default: null
    },
    linkHoverColor: {
      type: String,
      default: null
    },
    linkActiveColor: {
      type: String,
      default: null
    },
    cardStyle: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    P((n) => ({
      "40ea043c": a.background,
      "251182f9": a.titleColor,
      "78f75758": a.dividerColor,
      "57f7b2bb": a.linkColor,
      "617aa1a2": a.linkHoverColor,
      "158fd555": a.linkActiveColor
    }));
    const a = e, l = M();
    return (n, d) => (t(), i("section", pi, [
      o("div", {
        class: h([
          "list-magazine-articles",
          e.background ? "list-magazine-articles--background" : ""
        ])
      }, [
        s(n.$slots, "heading", {
          classes: [
            "list-magazine-articles__heading",
            `list-magazine-articles__heading--${e.listStyle}`,
            {
              "list-magazine-articles__heading--divider": e.enableHeadingDivider
            }
          ]
        }, () => [
          e.heading ? (t(), i("h2", {
            key: 0,
            class: h([
              "list-magazine-articles__heading",
              `list-magazine-articles__heading--${e.listStyle}`,
              {
                "list-magazine-articles__heading--divider": e.enableHeadingDivider
              }
            ])
          }, b(e.heading), 3)) : r("", !0)
        ], !0),
        o("ul", {
          class: h([
            "list-magazine-articles__list",
            `list-magazine-articles__list--${e.listStyle}`,
            e.enableItemDivider ? "list-magazine-articles__list--divider" : ""
          ])
        }, [
          (t(!0), i(B, null, D(e.items, (c) => {
            var k, u, f, g, p, m, _, y;
            return t(), i("li", {
              key: c.id,
              class: "list-magazine-articles__list-item"
            }, [
              T(Fn, {
                url: c.url,
                title: c.title,
                description: c.description,
                image: c.image,
                date: c.date,
                background: (k = e.cardStyle) == null ? void 0 : k.background,
                "title-color": (u = e.cardStyle) == null ? void 0 : u.titleColor,
                "title-hover-color": (f = e.cardStyle) == null ? void 0 : f.titleHoverColor,
                "text-color": (g = e.cardStyle) == null ? void 0 : g.textColor,
                "date-color": (p = e.cardStyle) == null ? void 0 : p.dateColor,
                "button-color": (m = e.cardStyle) == null ? void 0 : m.buttonColor,
                "button-hover-color": (_ = e.cardStyle) == null ? void 0 : _.buttonHoverColor,
                "button-active-color": (y = e.cardStyle) == null ? void 0 : y.buttonActiveColor
              }, Z({ _: 2 }, [
                v(l).itemImage ? {
                  name: "image",
                  fn: C(({ classes: w }) => [
                    s(n.$slots, "itemImage", {
                      image: c.image,
                      classes: w
                    }, void 0, !0)
                  ]),
                  key: "0"
                } : void 0,
                v(l).itemTitle ? {
                  name: "title",
                  fn: C(({ classes: w }) => [
                    s(n.$slots, "itemTitle", {
                      title: c.title,
                      classes: w
                    }, void 0, !0)
                  ]),
                  key: "1"
                } : void 0,
                v(l).itemDate ? {
                  name: "date",
                  fn: C(({ classes: w }) => [
                    s(n.$slots, "itemDate", {
                      date: c.date,
                      classes: w
                    }, void 0, !0)
                  ]),
                  key: "2"
                } : void 0,
                v(l).itemDescription ? {
                  name: "description",
                  fn: C(({ classes: w }) => [
                    s(n.$slots, "itemDescription", {
                      description: c.description || c.alternativeDescription,
                      classes: w
                    }, void 0, !0)
                  ]),
                  key: "3"
                } : void 0
              ]), 1032, ["url", "title", "description", "image", "date", "background", "title-color", "title-hover-color", "text-color", "date-color", "button-color", "button-hover-color", "button-active-color"])
            ]);
          }), 128))
        ], 2),
        s(n.$slots, "link", { classes: ["list-magazine-articles__action"] }, () => [
          e.linkUrl && e.linkLabel ? (t(), i("a", {
            key: 0,
            href: e.linkUrl,
            target: "_self",
            class: "list-magazine-articles__action"
          }, b(e.linkLabel), 9, _i)) : r("", !0)
        ], !0)
      ], 2)
    ]));
  }
}, ss = /* @__PURE__ */ x($i, [["__scopeId", "data-v-296df6d9"]]), Ci = { class: "logo-with-button-container" }, wi = { class: "logo-with-button" }, Pi = ["src", "alt"], xi = { class: "logo-with-button__content" }, Ii = {
  key: 0,
  class: "logo-with-button__content-title u-bold"
}, Li = {
  key: 0,
  class: "logo-with-button__content-text"
}, Ti = {
  __name: "ds-organism-logo-with-button",
  props: {
    image: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      default: ""
    },
    buttonLink: {
      type: String,
      default: ""
    },
    background: {
      type: String,
      default: null
    },
    borderColor: {
      type: String,
      default: null
    },
    titleColor: {
      type: String,
      default: null
    },
    textColor: {
      type: String,
      default: null
    },
    buttonStyle: {
      type: String,
      default: "secondary"
    }
  },
  setup(e) {
    P((l) => ({
      "7cee684f": a.background,
      "2cfc50d4": a.borderColor,
      "6115e70c": a.titleColor,
      "5395b2f5": a.textColor
    }));
    const a = e;
    return (l, n) => (t(), i("div", Ci, [
      o("article", wi, [
        s(l.$slots, "image", { classes: ["logo-with-button__image"] }, () => [
          e.image ? (t(), i("img", {
            key: 0,
            class: "logo-with-button__image",
            src: e.image.src,
            alt: e.image.alt || ""
          }, null, 8, Pi)) : r("", !0)
        ], !0),
        o("div", xi, [
          s(l.$slots, "title", { classes: ["logo-with-button__content-title"] }, () => [
            e.title ? (t(), i("h4", Ii, b(e.title), 1)) : r("", !0)
          ], !0),
          s(l.$slots, "text", { classes: ["logo-with-button__content-text"] }, () => [
            e.text ? (t(), i("p", Li, b(e.text), 1)) : r("", !0)
          ], !0)
        ]),
        s(l.$slots, "button", { classes: ["logo-with-button__button"] }, () => [
          T(N, {
            text: e.buttonText,
            href: e.buttonLink,
            "button-type": e.buttonStyle,
            size: "medium",
            "full-width": !0
          }, {
            text: C(({ classes: d }) => [
              s(l.$slots, "buttonText", { classes: d }, void 0, !0)
            ]),
            _: 3
          }, 8, ["text", "href", "button-type"])
        ], !0)
      ])
    ]));
  }
}, rs = /* @__PURE__ */ x(Ti, [["__scopeId", "data-v-3e048472"]]);
var G = {}, J = {}, be;
function Ei() {
  if (be) return J;
  be = 1;
  function e(a, l) {
    for (var n = [], d = a; d <= l; d++)
      n.push(d);
    return n;
  }
  return J.createRange = e, J;
}
var R = {}, j = {}, ye;
function Pe() {
  return ye || (ye = 1, j.ITEM_TYPES = {
    PAGE: "PAGE",
    ELLIPSIS: "ELLIPSIS",
    FIRST_PAGE_LINK: "FIRST_PAGE_LINK",
    PREVIOUS_PAGE_LINK: "PREVIOUS_PAGE_LINK",
    NEXT_PAGE_LINK: "NEXT_PAGE_LINK",
    LAST_PAGE_LINK: "LAST_PAGE_LINK"
  }, j.ITEM_KEYS = {
    FIRST_ELLIPSIS: -1,
    SECOND_ELLIPSIS: -2,
    FIRST_PAGE_LINK: -3,
    PREVIOUS_PAGE_LINK: -4,
    NEXT_PAGE_LINK: -5,
    LAST_PAGE_LINK: -6
  }), j;
}
var ke;
function Ai() {
  if (ke) return R;
  ke = 1;
  var e = Pe();
  return R.createFirstEllipsis = function(a) {
    return {
      type: e.ITEM_TYPES.ELLIPSIS,
      key: e.ITEM_KEYS.FIRST_ELLIPSIS,
      value: a,
      isActive: !1
    };
  }, R.createSecondEllipsis = function(a) {
    return {
      type: e.ITEM_TYPES.ELLIPSIS,
      key: e.ITEM_KEYS.SECOND_ELLIPSIS,
      value: a,
      isActive: !1
    };
  }, R.createFirstPageLink = function(a) {
    var l = a.currentPage;
    return {
      type: e.ITEM_TYPES.FIRST_PAGE_LINK,
      key: e.ITEM_KEYS.FIRST_PAGE_LINK,
      value: 1,
      isActive: l === 1
    };
  }, R.createPreviousPageLink = function(a) {
    var l = a.currentPage;
    return {
      type: e.ITEM_TYPES.PREVIOUS_PAGE_LINK,
      key: e.ITEM_KEYS.PREVIOUS_PAGE_LINK,
      value: Math.max(1, l - 1),
      isActive: l === 1
    };
  }, R.createNextPageLink = function(a) {
    var l = a.currentPage, n = a.totalPages;
    return {
      type: e.ITEM_TYPES.NEXT_PAGE_LINK,
      key: e.ITEM_KEYS.NEXT_PAGE_LINK,
      value: Math.min(n, l + 1),
      isActive: l === n
    };
  }, R.createLastPageLink = function(a) {
    var l = a.currentPage, n = a.totalPages;
    return {
      type: e.ITEM_TYPES.LAST_PAGE_LINK,
      key: e.ITEM_KEYS.LAST_PAGE_LINK,
      value: n,
      isActive: l === n
    };
  }, R.createPageFunctionFactory = function(a) {
    var l = a.currentPage;
    return function(n) {
      return {
        type: e.ITEM_TYPES.PAGE,
        key: n,
        value: n,
        isActive: n === l
      };
    };
  }, R;
}
var ve;
function Bi() {
  if (ve) return G;
  ve = 1;
  var e = Ei(), a = Ai();
  function l(d) {
    if (d == null)
      throw new Error("getPaginationModel(): options object should be a passed");
    var c = Number(d.totalPages);
    if (isNaN(c))
      throw new Error("getPaginationModel(): totalPages should be a number");
    if (c < 0)
      throw new Error("getPaginationModel(): totalPages shouldn't be a negative number");
    var k = Number(d.currentPage);
    if (isNaN(k))
      throw new Error("getPaginationModel(): currentPage should be a number");
    if (k < 0)
      throw new Error("getPaginationModel(): currentPage shouldn't be a negative number");
    if (k > c)
      throw new Error("getPaginationModel(): currentPage shouldn't be greater than totalPages");
    var u = d.boundaryPagesRange == null ? 1 : Number(d.boundaryPagesRange);
    if (isNaN(u))
      throw new Error("getPaginationModel(): boundaryPagesRange should be a number");
    if (u < 0)
      throw new Error("getPaginationModel(): boundaryPagesRange shouldn't be a negative number");
    var f = d.siblingPagesRange == null ? 1 : Number(d.siblingPagesRange);
    if (isNaN(f))
      throw new Error("getPaginationModel(): siblingPagesRange should be a number");
    if (f < 0)
      throw new Error("getPaginationModel(): siblingPagesRange shouldn't be a negative number");
    var g = !!d.hidePreviousAndNextPageLinks, p = !!d.hideFirstAndLastPageLinks, m = !!d.hideEllipsis, _ = m ? 0 : 1, y = [], w = a.createPageFunctionFactory(d);
    if (p || y.push(a.createFirstPageLink(d)), g || y.push(a.createPreviousPageLink(d)), 1 + 2 * _ + 2 * f + 2 * u >= c) {
      var U = e.createRange(1, c).map(w);
      y.push.apply(y, U);
    } else {
      var X = 1, V = u, q = e.createRange(X, V).map(w), S = c + 1 - u, I = c, E = e.createRange(S, I).map(w), z = Math.min(Math.max(k - f, V + _ + 1), S - _ - 2 * f - 1), W = z + 2 * f, xe = e.createRange(z, W).map(w);
      if (y.push.apply(y, q), !m) {
        var re = z - 1, Ie = re === V + 1, Le = Ie ? w : a.createFirstEllipsis, Te = Le(re);
        y.push(Te);
      }
      if (y.push.apply(y, xe), !m) {
        var oe = W + 1, Ee = oe === S - 1, Ae = Ee ? w : a.createSecondEllipsis, Be = Ae(oe);
        y.push(Be);
      }
      y.push.apply(y, E);
    }
    return g || y.push(a.createNextPageLink(d)), p || y.push(a.createLastPageLink(d)), y;
  }
  G.getPaginationModel = l;
  var n = Pe();
  return G.ITEM_TYPES = n.ITEM_TYPES, G.ITEM_KEYS = n.ITEM_KEYS, G;
}
var Mi = Bi();
const Di = { class: "pagination-container" }, Hi = {
  class: "pagination",
  role: "navigation"
}, os = {
  __name: "ds-organism-pagination",
  props: {
    linkComponent: {
      type: String,
      default: "a"
    },
    totalPages: {
      type: Number,
      required: !0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    linkStructure: {
      type: String,
      default: "?page={{i}}"
    },
    ariaNextPage: {
      type: String,
      default: "Next page"
    },
    ariaPreviousPage: {
      type: String,
      default: "Previous page"
    },
    ariaPage: {
      type: String,
      default: "Page {{i}}"
    }
  },
  setup(e) {
    const a = e, l = K(), { device: n } = F(l), d = H(() => Mi.getPaginationModel({
      currentPage: a.currentPage,
      totalPages: a.totalPages,
      hideFirstAndLastPageLinks: !0,
      boundaryPagesRange: n.value === "mobile" ? 0 : 1,
      hideEllipsis: n.value === "mobile"
    }).filter((f) => (f.type !== "PREVIOUS_PAGE_LINK" || a.currentPage !== 1) && (f.type !== "NEXT_PAGE_LINK" || a.currentPage !== a.totalPages))), c = (u) => a.linkStructure.replace("{{i}}", u), k = (u) => u.type === "PREVIOUS_PAGE_LINK" ? a.ariaPreviousPage : u.type === "NEXT_PAGE_LINK" ? a.ariaNextPage : u.type === "PAGE" ? a.ariaPage.replace("{{i}}", u.value) : null;
    return (u, f) => (t(), i("div", Di, [
      o("nav", Hi, [
        (t(!0), i(B, null, D(d.value, (g) => (t(), $(O(e.linkComponent), {
          key: g.key,
          class: h([
            "pagination__button",
            {
              "pagination__button--active": g.isActive,
              "pagination__button--ellipsis": g.type === "ELLIPSIS",
              "pagination__button--navigation": g.type === "PREVIOUS_PAGE_LINK" || g.type === "NEXT_PAGE_LINK",
              "pagination__button--link": g.type === "PAGE" && !g.isActive
            }
          ]),
          href: g.type !== "ELLIPSIS" && !g.isActive ? c(g.value) : void 0,
          "aria-label": k(g)
        }, {
          default: C(() => [
            g.type === "PREVIOUS_PAGE_LINK" ? (t(), $(v(te), {
              key: 0,
              icon: v(pe),
              class: "pagination__navigation-icon"
            }, null, 8, ["icon"])) : g.type === "NEXT_PAGE_LINK" ? (t(), $(v(te), {
              key: 1,
              icon: v(_e),
              class: "pagination__navigation-icon"
            }, null, 8, ["icon"])) : g.type === "ELLIPSIS" ? (t(), i(B, { key: 2 }, [
              Q(" ... ")
            ], 64)) : (t(), i(B, { key: 3 }, [
              Q(b(g.value), 1)
            ], 64))
          ]),
          _: 2
        }, 1032, ["class", "href", "aria-label"]))), 128))
      ])
    ]));
  }
};
export {
  Ki as DsAtomBarProcess,
  N as DsAtomButton,
  qi as DsAtomHeading,
  A as DsAtomIcon,
  Gi as DsAtomInput,
  Yi as DsAtomSelect,
  ji as DsAtomTextarea,
  Xi as DsMoleculeItemIcon,
  Fn as DsMoleculeMagazineArticleCard,
  Wi as DsMoleculeSingleReview,
  we as DsMoleculeTrust,
  Ul as DsOrganismBlockInformation,
  Ji as DsOrganismCardIcon,
  he as DsOrganismCardImage,
  Fi as DsOrganismCardImageSmall,
  Qi as DsOrganismCardList,
  Zi as DsOrganismCardListLinks,
  es as DsOrganismContentColumnCheckmarks,
  ts as DsOrganismCtaBlock,
  as as DsOrganismCtaWithImage,
  ns as DsOrganismIconLinkBar,
  ls as DsOrganismImageList,
  is as DsOrganismLinkBlock,
  ss as DsOrganismListMagazineArticles,
  rs as DsOrganismLogoWithButton,
  os as DsOrganismPagination
};
//# sourceMappingURL=marketplaces.es.js.map
